// created by Garrett Lang on 1/29/2020

// usage: 
// <pre>{JSON.stringify({
//   'Enum Keys' : Enums.AppointmentTypes.keys(),
//   'Enum Vals' : Enums.AppointmentTypes.values(),
//   'Example' : {
//     'HAVE_APPOINTMENT' : Enums.AppointmentTypes.getValueByName('HAVE_APPOINTMENT'),
//     'Val(Need Appointment)' : Enums.AppointmentTypes.getNameByValue('Need Appointment')
//   }
// }, null, 4)}</pre>

import React from 'react';

// enum prototype
function Enum() {
    this.self = arguments[0];
}

Enum.prototype.keys = function () {
    return Object.keys(this.self);
};

Enum.prototype.values = function () {
    let me = this;
    return this.keys(this.self).map(function (key) {
        return me.self[key];
    });
};

Enum.prototype.getValueByName = function (key) {
    if (key !== undefined && key !== null) {
        return this.self[this.keys(this.self).filter(function (k) {
            return key === k;
        }).pop() || ''];
    } else {
        return '';
    }
};

Enum.prototype.getNameByValue = function (value) {
    if (value !== undefined && value !== null) {
        let me = this;
        return this.keys(this.self).filter(function (k) {
            return me.self[k] === value;
        }).pop() || '';
    } else {
        return '';
    }
};

Enum.prototype.selectListOptions = function () {
    let me = this;
    let enumList = this.keys(this.self).map(function (key) {
        return { key, value: me.self[key] };
    });

    let options = [];
    if (enumList.length >= 0) {
        enumList.forEach(function (item) {
            options.push(<option value={item.key} key={item.key}>{item.value}</option>);
        });
    }

    return options;
};

Enum.prototype.selectListOptionsWithExclusions = function (exclusionKeyList) {
    let me = this;
    let enumList = this.keys(this.self).map(function (key) {
        return { key, value: me.self[key] };
    });

    let options = [];
    if (enumList.length >= 0) {
        enumList.forEach(function (item) {
            if (!exclusionKeyList.includes(item.key)) {
                options.push(<option value={item.key} key={item.key}>{item.value}</option>);
            }
        });
    }

    return options;
};

Enum.prototype.selectListOptionsWithDisables = function (disabledKeyList) {
    let me = this;
    let enumList = this.keys(this.self).map(function (key) {
        return { key, value: me.self[key] };
    });

    let options = [];
    if (enumList.length >= 0) {
        enumList.forEach(function (item) {
            options.push(<option value={item.key} key={item.key} disabled={disabledKeyList.includes(item.key)}>{item.value}</option>);
        });
    }

    return options;
};

// array of value/text of name/value
Enum.prototype.getTextValueEnumArray = function () {
    let me = this;
    let enumList = this.keys(this.self).map(function (key) {
        return { value: key, text: me.self[key] };
    });

    return enumList;
};

// array of value/text of just the names
Enum.prototype.getTextValueNameArray = function () {
    let enumList = this.keys(this.self).map(function (key) {
        return { value: key, text: key };
    });

    return enumList;
};

// array of value/text of just the values
Enum.prototype.getTextValueValueArray = function () {
    let me = this;
    let enumList = this.keys(this.self).map(function (key) {
        return { value: me.self[key], text: me.self[key] };
    });

    return enumList;
};

Enum.prototype.getLabelValueKeyArray = function () {
    let me = this;
    let enumList = this.keys(this.self).map(function (key) {
        return { value: key, key: key, label: me.self[key] };
    });

    return enumList;
};

Enum.prototype.getLabelValueKeyArrayWithDisables = function (disabledKeyList) {
    let me = this;
    let enumList = this.keys(this.self).map(function (key) {
        return { value: key, key: key, label: me.self[key], disabled: false };
    });

    let options = [];
    if (enumList.length >= 0) {
        enumList.forEach(function (item) {
            item.disabled = disabledKeyList.includes(item.key);
            options.push(item);
        });
    }

    return options;
};

Enum.prototype.getLabelValueKeyArrayWithExclusions = function (exclusionKeyList) {
    let me = this;
    let enumList = this.keys(this.self).map(function (key) {
        return { value: key, key: key, label: me.self[key] };
    });

    let options = [];
    if (enumList.length >= 0) {
        enumList.forEach(function (item) {
            if (!exclusionKeyList.includes(item.key)) {
                options.push(item);
            }
        });
    }

    return options;
};

// Enum.prototype.getName = function () {
//     // search through the global object for a name that resolves to this object
//     for (var name in window)
//         if (window[name] == this)
//             return name;
// };

Enum.prototype.getName = function () {
    var funcNameRegex = /function (.{1,})\(/;
    var results = (funcNameRegex).exec((this).constructor.toString());
    return (results && results.length > 1) ? results[1] : "";
};

Enum.prototype.includesKey = function (key) {
    return this.keys().includes(key);
};

Enum.prototype.includesValue = function (value) {
    return this.values().includes(value);
};

// define all enums below

const Currencies = new Enum({
    USD: 'USD',
});

const TimeUnits = new Enum({
    MIN: 'mins',
    SECS: 'secs',
});

const DistanceUnits = new Enum({
    MI: 'mi',
});

const LengthUnits = new Enum({
    FT: 'ft',
});

const WeightUnits = new Enum({
    LB: 'lbs',
});

const VolumeUnits = new Enum({
    GAL: 'gals',
});

const TemperatureUnits = new Enum({
    F: 'F',
});

const UnitOfMeasure = new Enum({
    ENGLISH: 'English',
});

const Counts = new Enum({
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    10: 10,
    11: 11,
    12: 12,
    13: 13,
    14: 14,
    15: 15,
    16: 16,
    17: 17,
    18: 18,
    19: 19,
    20: 20,
});

const YesNo = new Enum({
    true: 'Yes',
    false: 'No',
});

const DayOfWeek = new Enum({
    MONDAY: 'Monday',
    TUESDAY: 'Tuesday',
    WEDNESDAY: 'Wednesday',
    THURSDAY: 'Thursday',
    FRIDAY: 'Friday',
    SATURDAY: 'Saturday',
    SUNDAY: 'Sunday',
});

const ResumeLinkRevokedReasons = new Enum({
    SUBSCRIPTION_CREATED: 'Subscription Created', // SUBSCRIPTION_CREATED: the cart this link resumed converted
    ENCOUNTER_CREATED: 'Encounter Created', // ENCOUNTER_CREATED: kept for a consult conversion that can name its lead one day; a consult today truncates
    SUBSCRIPTION_REACTIVATED: 'Subscription Reactivated', // SUBSCRIPTION_REACTIVATED: the subscription a win-back link was minted for is active again
    MFA_ENROLLED: 'Second Factor Enrolled', // MFA_ENROLLED: a custom token would sign in without the second factor, so the link is closed
    PRIVILEGED_ACCOUNT: 'Privileged Account', // PRIVILEGED_ACCOUNT: the account holds a staff or partner role, which never signs in from a link
    ACCOUNT_DISABLED: 'Account Disabled', // ACCOUNT_DISABLED: the auth account was disabled before the link was clicked
    ACCOUNT_DELETED: 'Account Deleted', // ACCOUNT_DELETED: the auth account no longer existed when the link was clicked
});

const ResumeLinkTypes = new Enum({
    ABANDONED_CART: 'Abandoned Cart', // ABANDONED_CART: resumes a lead's own cart; minted at lead creation, a year for a lead
    CROSS_SELL: 'Cross-Sell', // CROSS_SELL: opens the funnel for another program for an existing customer; minted per email, a day
    WIN_BACK: 'Win-Back', // WIN_BACK: opens the reactivation page for a cancelled subscription; minted per email, a day
});

const ResumeLinkMintSources = new Enum({
    LEAD_CREATED: 'Lead Created', // LEAD_CREATED: the platform minted it on the lead's creation trigger
    WEBHOOK: 'Webhook', // WEBHOOK: a customer.io workflow step asked for it before an email
});

const SignInMethods = new Enum({
    RESUME_LINK: 'Resume Link', // RESUME_LINK: the session was minted from an abandoned-cart resume link, not a password
});

const CallStatuses = new Enum({
    PENDING: 'Pending', // PENDING: Auto-created, team has not triaged yet
    NEEDED: 'Needed', // NEEDED: Outreach required but not yet scheduled
    SCHEDULED: 'Scheduled', // SCHEDULED: Call appointment arranged with the patient
    ATTEMPTED: 'Attempted', // ATTEMPTED: Contact attempt made without successful connection
    DECLINED: 'Declined', // DECLINED: Patient opted out of a welcome call
    COMPLETED: 'Completed', // COMPLETED: Welcome call successfully finished
    CANCELLED: 'Cancelled', // CANCELLED: Scheduled then cancelled
    CLOSED: 'Closed', // CLOSED: Admin closed it out but the call may not necessarily have been completed
});

const ContactMethods = new Enum({
    EMAIL: 'Email',
    SMS: 'Text Message',
    CALL: 'Call',
});

const CallWindowPreferences = new Enum({
    ANYTIME: 'Anytime',
    WEEKDAY_MORNINGS: 'Weekday Mornings',
    WEEKDAY_AFTERNOONS: 'Weekday Afternoons',
    WEEKDAY_EVENINGS: 'Weekday Evenings',
    WEEKEND_MORNINGS: 'Weekend Mornings',
    WEEKEND_AFTERNOONS: 'Weekend Afternoons',
    WEEKEND_EVENINGS: 'Weekend Evenings',
});

const TimeZones = new Enum({
    'Africa/Abidjan': 'Africa/Abidjan',
    'Africa/Accra': 'Africa/Accra',
    'Africa/Addis_Ababa': 'Africa/Addis_Ababa',
    'Africa/Algiers': 'Africa/Algiers',
    'Africa/Asmara': 'Africa/Asmara',
    'Africa/Asmera': 'Africa/Asmera',
    'Africa/Bamako': 'Africa/Bamako',
    'Africa/Bangui': 'Africa/Bangui',
    'Africa/Banjul': 'Africa/Banjul',
    'Africa/Bissau': 'Africa/Bissau',
    'Africa/Blantyre': 'Africa/Blantyre',
    'Africa/Brazzaville': 'Africa/Brazzaville',
    'Africa/Bujumbura': 'Africa/Bujumbura',
    'Africa/Cairo': 'Africa/Cairo',
    'Africa/Casablanca': 'Africa/Casablanca',
    'Africa/Ceuta': 'Africa/Ceuta',
    'Africa/Conakry': 'Africa/Conakry',
    'Africa/Dakar': 'Africa/Dakar',
    'Africa/Dar_es_Salaam': 'Africa/Dar_es_Salaam',
    'Africa/Djibouti': 'Africa/Djibouti',
    'Africa/Douala': 'Africa/Douala',
    'Africa/El_Aaiun': 'Africa/El_Aaiun',
    'Africa/Freetown': 'Africa/Freetown',
    'Africa/Gaborone': 'Africa/Gaborone',
    'Africa/Harare': 'Africa/Harare',
    'Africa/Johannesburg': 'Africa/Johannesburg',
    'Africa/Juba': 'Africa/Juba',
    'Africa/Kampala': 'Africa/Kampala',
    'Africa/Khartoum': 'Africa/Khartoum',
    'Africa/Kigali': 'Africa/Kigali',
    'Africa/Kinshasa': 'Africa/Kinshasa',
    'Africa/Lagos': 'Africa/Lagos',
    'Africa/Libreville': 'Africa/Libreville',
    'Africa/Lome': 'Africa/Lome',
    'Africa/Luanda': 'Africa/Luanda',
    'Africa/Lubumbashi': 'Africa/Lubumbashi',
    'Africa/Lusaka': 'Africa/Lusaka',
    'Africa/Malabo': 'Africa/Malabo',
    'Africa/Maputo': 'Africa/Maputo',
    'Africa/Maseru': 'Africa/Maseru',
    'Africa/Mbabane': 'Africa/Mbabane',
    'Africa/Mogadishu': 'Africa/Mogadishu',
    'Africa/Monrovia': 'Africa/Monrovia',
    'Africa/Nairobi': 'Africa/Nairobi',
    'Africa/Ndjamena': 'Africa/Ndjamena',
    'Africa/Niamey': 'Africa/Niamey',
    'Africa/Nouakchott': 'Africa/Nouakchott',
    'Africa/Ouagadougou': 'Africa/Ouagadougou',
    'Africa/Porto-Novo': 'Africa/Porto-Novo',
    'Africa/Sao_Tome': 'Africa/Sao_Tome',
    'Africa/Timbuktu': 'Africa/Timbuktu',
    'Africa/Tripoli': 'Africa/Tripoli',
    'Africa/Tunis': 'Africa/Tunis',
    'Africa/Windhoek': 'Africa/Windhoek',
    'America/Adak': 'America/Adak',
    'America/Anchorage': 'America/Anchorage',
    'America/Anguilla': 'America/Anguilla',
    'America/Antigua': 'America/Antigua',
    'America/Araguaina': 'America/Araguaina',
    'America/Argentina/Buenos_Aires': 'America/Argentina/Buenos_Aires',
    'America/Argentina/Catamarca': 'America/Argentina/Catamarca',
    'America/Argentina/ComodRivadavia': 'America/Argentina/ComodRivadavia',
    'America/Argentina/Cordoba': 'America/Argentina/Cordoba',
    'America/Argentina/Jujuy': 'America/Argentina/Jujuy',
    'America/Argentina/La_Rioja': 'America/Argentina/La_Rioja',
    'America/Argentina/Mendoza': 'America/Argentina/Mendoza',
    'America/Argentina/Rio_Gallegos': 'America/Argentina/Rio_Gallegos',
    'America/Argentina/Salta': 'America/Argentina/Salta',
    'America/Argentina/San_Juan': 'America/Argentina/San_Juan',
    'America/Argentina/San_Luis': 'America/Argentina/San_Luis',
    'America/Argentina/Tucuman': 'America/Argentina/Tucuman',
    'America/Argentina/Ushuaia': 'America/Argentina/Ushuaia',
    'America/Aruba': 'America/Aruba',
    'America/Asuncion': 'America/Asuncion',
    'America/Atikokan': 'America/Atikokan',
    'America/Atka': 'America/Atka',
    'America/Bahia': 'America/Bahia',
    'America/Bahia_Banderas': 'America/Bahia_Banderas',
    'America/Barbados': 'America/Barbados',
    'America/Belem': 'America/Belem',
    'America/Belize': 'America/Belize',
    'America/Blanc-Sablon': 'America/Blanc-Sablon',
    'America/Boa_Vista': 'America/Boa_Vista',
    'America/Bogota': 'America/Bogota',
    'America/Boise': 'America/Boise',
    'America/Buenos_Aires': 'America/Buenos_Aires',
    'America/Cambridge_Bay': 'America/Cambridge_Bay',
    'America/Campo_Grande': 'America/Campo_Grande',
    'America/Cancun': 'America/Cancun',
    'America/Caracas': 'America/Caracas',
    'America/Catamarca': 'America/Catamarca',
    'America/Cayenne': 'America/Cayenne',
    'America/Cayman': 'America/Cayman',
    'America/Chicago': 'America/Chicago',
    'America/Chihuahua': 'America/Chihuahua',
    'America/Coral_Harbour': 'America/Coral_Harbour',
    'America/Cordoba': 'America/Cordoba',
    'America/Costa_Rica': 'America/Costa_Rica',
    'America/Creston': 'America/Creston',
    'America/Cuiaba': 'America/Cuiaba',
    'America/Curacao': 'America/Curacao',
    'America/Danmarkshavn': 'America/Danmarkshavn',
    'America/Dawson': 'America/Dawson',
    'America/Dawson_Creek': 'America/Dawson_Creek',
    'America/Denver': 'America/Denver',
    'America/Detroit': 'America/Detroit',
    'America/Dominica': 'America/Dominica',
    'America/Edmonton': 'America/Edmonton',
    'America/Eirunepe': 'America/Eirunepe',
    'America/El_Salvador': 'America/El_Salvador',
    'America/Ensenada': 'America/Ensenada',
    'America/Fort_Nelson': 'America/Fort_Nelson',
    'America/Fort_Wayne': 'America/Fort_Wayne',
    'America/Fortaleza': 'America/Fortaleza',
    'America/Glace_Bay': 'America/Glace_Bay',
    'America/Godthab': 'America/Godthab',
    'America/Goose_Bay': 'America/Goose_Bay',
    'America/Grand_Turk': 'America/Grand_Turk',
    'America/Grenada': 'America/Grenada',
    'America/Guadeloupe': 'America/Guadeloupe',
    'America/Guatemala': 'America/Guatemala',
    'America/Guayaquil': 'America/Guayaquil',
    'America/Guyana': 'America/Guyana',
    'America/Halifax': 'America/Halifax',
    'America/Havana': 'America/Havana',
    'America/Hermosillo': 'America/Hermosillo',
    'America/Indiana/Indianapolis': 'America/Indiana/Indianapolis',
    'America/Indiana/Knox': 'America/Indiana/Knox',
    'America/Indiana/Marengo': 'America/Indiana/Marengo',
    'America/Indiana/Petersburg': 'America/Indiana/Petersburg',
    'America/Indiana/Tell_City': 'America/Indiana/Tell_City',
    'America/Indiana/Vevay': 'America/Indiana/Vevay',
    'America/Indiana/Vincennes': 'America/Indiana/Vincennes',
    'America/Indiana/Winamac': 'America/Indiana/Winamac',
    'America/Indianapolis': 'America/Indianapolis',
    'America/Inuvik': 'America/Inuvik',
    'America/Iqaluit': 'America/Iqaluit',
    'America/Jamaica': 'America/Jamaica',
    'America/Jujuy': 'America/Jujuy',
    'America/Juneau': 'America/Juneau',
    'America/Kentucky/Louisville': 'America/Kentucky/Louisville',
    'America/Kentucky/Monticello': 'America/Kentucky/Monticello',
    'America/Knox_IN': 'America/Knox_IN',
    'America/Kralendijk': 'America/Kralendijk',
    'America/La_Paz': 'America/La_Paz',
    'America/Lima': 'America/Lima',
    'America/Los_Angeles': 'America/Los_Angeles',
    'America/Louisville': 'America/Louisville',
    'America/Lower_Princes': 'America/Lower_Princes',
    'America/Maceio': 'America/Maceio',
    'America/Managua': 'America/Managua',
    'America/Manaus': 'America/Manaus',
    'America/Marigot': 'America/Marigot',
    'America/Martinique': 'America/Martinique',
    'America/Matamoros': 'America/Matamoros',
    'America/Mazatlan': 'America/Mazatlan',
    'America/Mendoza': 'America/Mendoza',
    'America/Menominee': 'America/Menominee',
    'America/Merida': 'America/Merida',
    'America/Metlakatla': 'America/Metlakatla',
    'America/Mexico_City': 'America/Mexico_City',
    'America/Miquelon': 'America/Miquelon',
    'America/Moncton': 'America/Moncton',
    'America/Monterrey': 'America/Monterrey',
    'America/Montevideo': 'America/Montevideo',
    'America/Montreal': 'America/Montreal',
    'America/Montserrat': 'America/Montserrat',
    'America/Nassau': 'America/Nassau',
    'America/New_York': 'America/New_York',
    'America/Nipigon': 'America/Nipigon',
    'America/Nome': 'America/Nome',
    'America/Noronha': 'America/Noronha',
    'America/North_Dakota/Beulah': 'America/North_Dakota/Beulah',
    'America/North_Dakota/Center': 'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem': 'America/North_Dakota/New_Salem',
    'America/Ojinaga': 'America/Ojinaga',
    'America/Panama': 'America/Panama',
    'America/Pangnirtung': 'America/Pangnirtung',
    'America/Paramaribo': 'America/Paramaribo',
    'America/Phoenix': 'America/Phoenix',
    'America/Port-au-Prince': 'America/Port-au-Prince',
    'America/Port_of_Spain': 'America/Port_of_Spain',
    'America/Porto_Acre': 'America/Porto_Acre',
    'America/Porto_Velho': 'America/Porto_Velho',
    'America/Puerto_Rico': 'America/Puerto_Rico',
    'America/Punta_Arenas': 'America/Punta_Arenas',
    'America/Rainy_River': 'America/Rainy_River',
    'America/Rankin_Inlet': 'America/Rankin_Inlet',
    'America/Recife': 'America/Recife',
    'America/Regina': 'America/Regina',
    'America/Resolute': 'America/Resolute',
    'America/Rio_Branco': 'America/Rio_Branco',
    'America/Rosario': 'America/Rosario',
    'America/Santa_Isabel': 'America/Santa_Isabel',
    'America/Santarem': 'America/Santarem',
    'America/Santiago': 'America/Santiago',
    'America/Santo_Domingo': 'America/Santo_Domingo',
    'America/Sao_Paulo': 'America/Sao_Paulo',
    'America/Scoresbysund': 'America/Scoresbysund',
    'America/Shiprock': 'America/Shiprock',
    'America/Sitka': 'America/Sitka',
    'America/St_Barthelemy': 'America/St_Barthelemy',
    'America/St_Johns': 'America/St_Johns',
    'America/St_Kitts': 'America/St_Kitts',
    'America/St_Lucia': 'America/St_Lucia',
    'America/St_Thomas': 'America/St_Thomas',
    'America/St_Vincent': 'America/St_Vincent',
    'America/Swift_Current': 'America/Swift_Current',
    'America/Tegucigalpa': 'America/Tegucigalpa',
    'America/Thule': 'America/Thule',
    'America/Thunder_Bay': 'America/Thunder_Bay',
    'America/Tijuana': 'America/Tijuana',
    'America/Toronto': 'America/Toronto',
    'America/Tortola': 'America/Tortola',
    'America/Vancouver': 'America/Vancouver',
    'America/Virgin': 'America/Virgin',
    'America/Whitehorse': 'America/Whitehorse',
    'America/Winnipeg': 'America/Winnipeg',
    'America/Yakutat': 'America/Yakutat',
    'America/Yellowknife': 'America/Yellowknife',
    'Antarctica/Casey': 'Antarctica/Casey',
    'Antarctica/Davis': 'Antarctica/Davis',
    'Antarctica/DumontDUrville': 'Antarctica/DumontDUrville',
    'Antarctica/Macquarie': 'Antarctica/Macquarie',
    'Antarctica/Mawson': 'Antarctica/Mawson',
    'Antarctica/McMurdo': 'Antarctica/McMurdo',
    'Antarctica/Palmer': 'Antarctica/Palmer',
    'Antarctica/Rothera': 'Antarctica/Rothera',
    'Antarctica/South_Pole': 'Antarctica/South_Pole',
    'Antarctica/Syowa': 'Antarctica/Syowa',
    'Antarctica/Troll': 'Antarctica/Troll',
    'Antarctica/Vostok': 'Antarctica/Vostok',
    'Arctic/Longyearbyen': 'Arctic/Longyearbyen',
    'Asia/Aden': 'Asia/Aden',
    'Asia/Almaty': 'Asia/Almaty',
    'Asia/Amman': 'Asia/Amman',
    'Asia/Anadyr': 'Asia/Anadyr',
    'Asia/Aqtau': 'Asia/Aqtau',
    'Asia/Aqtobe': 'Asia/Aqtobe',
    'Asia/Ashgabat': 'Asia/Ashgabat',
    'Asia/Ashkhabad': 'Asia/Ashkhabad',
    'Asia/Atyrau': 'Asia/Atyrau',
    'Asia/Baghdad': 'Asia/Baghdad',
    'Asia/Bahrain': 'Asia/Bahrain',
    'Asia/Baku': 'Asia/Baku',
    'Asia/Bangkok': 'Asia/Bangkok',
    'Asia/Barnaul': 'Asia/Barnaul',
    'Asia/Beirut': 'Asia/Beirut',
    'Asia/Bishkek': 'Asia/Bishkek',
    'Asia/Brunei': 'Asia/Brunei',
    'Asia/Calcutta': 'Asia/Calcutta',
    'Asia/Chita': 'Asia/Chita',
    'Asia/Choibalsan': 'Asia/Choibalsan',
    'Asia/Chongqing': 'Asia/Chongqing',
    'Asia/Chungking': 'Asia/Chungking',
    'Asia/Colombo': 'Asia/Colombo',
    'Asia/Dacca': 'Asia/Dacca',
    'Asia/Damascus': 'Asia/Damascus',
    'Asia/Dhaka': 'Asia/Dhaka',
    'Asia/Dili': 'Asia/Dili',
    'Asia/Dubai': 'Asia/Dubai',
    'Asia/Dushanbe': 'Asia/Dushanbe',
    'Asia/Famagusta': 'Asia/Famagusta',
    'Asia/Gaza': 'Asia/Gaza',
    'Asia/Harbin': 'Asia/Harbin',
    'Asia/Hebron': 'Asia/Hebron',
    'Asia/Ho_Chi_Minh': 'Asia/Ho_Chi_Minh',
    'Asia/Hong_Kong': 'Asia/Hong_Kong',
    'Asia/Hovd': 'Asia/Hovd',
    'Asia/Irkutsk': 'Asia/Irkutsk',
    'Asia/Istanbul': 'Asia/Istanbul',
    'Asia/Jakarta': 'Asia/Jakarta',
    'Asia/Jayapura': 'Asia/Jayapura',
    'Asia/Jerusalem': 'Asia/Jerusalem',
    'Asia/Kabul': 'Asia/Kabul',
    'Asia/Kamchatka': 'Asia/Kamchatka',
    'Asia/Karachi': 'Asia/Karachi',
    'Asia/Kashgar': 'Asia/Kashgar',
    'Asia/Kathmandu': 'Asia/Kathmandu',
    'Asia/Katmandu': 'Asia/Katmandu',
    'Asia/Khandyga': 'Asia/Khandyga',
    'Asia/Kolkata': 'Asia/Kolkata',
    'Asia/Krasnoyarsk': 'Asia/Krasnoyarsk',
    'Asia/Kuala_Lumpur': 'Asia/Kuala_Lumpur',
    'Asia/Kuching': 'Asia/Kuching',
    'Asia/Kuwait': 'Asia/Kuwait',
    'Asia/Macao': 'Asia/Macao',
    'Asia/Macau': 'Asia/Macau',
    'Asia/Magadan': 'Asia/Magadan',
    'Asia/Makassar': 'Asia/Makassar',
    'Asia/Manila': 'Asia/Manila',
    'Asia/Muscat': 'Asia/Muscat',
    'Asia/Nicosia': 'Asia/Nicosia',
    'Asia/Novokuznetsk': 'Asia/Novokuznetsk',
    'Asia/Novosibirsk': 'Asia/Novosibirsk',
    'Asia/Omsk': 'Asia/Omsk',
    'Asia/Oral': 'Asia/Oral',
    'Asia/Phnom_Penh': 'Asia/Phnom_Penh',
    'Asia/Pontianak': 'Asia/Pontianak',
    'Asia/Pyongyang': 'Asia/Pyongyang',
    'Asia/Qatar': 'Asia/Qatar',
    'Asia/Qostanay': 'Asia/Qostanay',
    'Asia/Qyzylorda': 'Asia/Qyzylorda',
    'Asia/Rangoon': 'Asia/Rangoon',
    'Asia/Riyadh': 'Asia/Riyadh',
    'Asia/Saigon': 'Asia/Saigon',
    'Asia/Sakhalin': 'Asia/Sakhalin',
    'Asia/Samarkand': 'Asia/Samarkand',
    'Asia/Seoul': 'Asia/Seoul',
    'Asia/Shanghai': 'Asia/Shanghai',
    'Asia/Singapore': 'Asia/Singapore',
    'Asia/Srednekolymsk': 'Asia/Srednekolymsk',
    'Asia/Taipei': 'Asia/Taipei',
    'Asia/Tashkent': 'Asia/Tashkent',
    'Asia/Tbilisi': 'Asia/Tbilisi',
    'Asia/Tehran': 'Asia/Tehran',
    'Asia/Tel_Aviv': 'Asia/Tel_Aviv',
    'Asia/Thimbu': 'Asia/Thimbu',
    'Asia/Thimphu': 'Asia/Thimphu',
    'Asia/Tokyo': 'Asia/Tokyo',
    'Asia/Tomsk': 'Asia/Tomsk',
    'Asia/Ujung_Pandang': 'Asia/Ujung_Pandang',
    'Asia/Ulaanbaatar': 'Asia/Ulaanbaatar',
    'Asia/Ulan_Bator': 'Asia/Ulan_Bator',
    'Asia/Urumqi': 'Asia/Urumqi',
    'Asia/Ust-Nera': 'Asia/Ust-Nera',
    'Asia/Vientiane': 'Asia/Vientiane',
    'Asia/Vladivostok': 'Asia/Vladivostok',
    'Asia/Yakutsk': 'Asia/Yakutsk',
    'Asia/Yangon': 'Asia/Yangon',
    'Asia/Yekaterinburg': 'Asia/Yekaterinburg',
    'Asia/Yerevan': 'Asia/Yerevan',
    'Atlantic/Azores': 'Atlantic/Azores',
    'Atlantic/Bermuda': 'Atlantic/Bermuda',
    'Atlantic/Canary': 'Atlantic/Canary',
    'Atlantic/Cape_Verde': 'Atlantic/Cape_Verde',
    'Atlantic/Faeroe': 'Atlantic/Faeroe',
    'Atlantic/Faroe': 'Atlantic/Faroe',
    'Atlantic/Jan_Mayen': 'Atlantic/Jan_Mayen',
    'Atlantic/Madeira': 'Atlantic/Madeira',
    'Atlantic/Reykjavik': 'Atlantic/Reykjavik',
    'Atlantic/South_Georgia': 'Atlantic/South_Georgia',
    'Atlantic/St_Helena': 'Atlantic/St_Helena',
    'Atlantic/Stanley': 'Atlantic/Stanley',
    'Australia/ACT': 'Australia/ACT',
    'Australia/Adelaide': 'Australia/Adelaide',
    'Australia/Brisbane': 'Australia/Brisbane',
    'Australia/Broken_Hill': 'Australia/Broken_Hill',
    'Australia/Canberra': 'Australia/Canberra',
    'Australia/Currie': 'Australia/Currie',
    'Australia/Darwin': 'Australia/Darwin',
    'Australia/Eucla': 'Australia/Eucla',
    'Australia/Hobart': 'Australia/Hobart',
    'Australia/LHI': 'Australia/LHI',
    'Australia/Lindeman': 'Australia/Lindeman',
    'Australia/Lord_Howe': 'Australia/Lord_Howe',
    'Australia/Melbourne': 'Australia/Melbourne',
    'Australia/NSW': 'Australia/NSW',
    'Australia/North': 'Australia/North',
    'Australia/Perth': 'Australia/Perth',
    'Australia/Queensland': 'Australia/Queensland',
    'Australia/South': 'Australia/South',
    'Australia/Sydney': 'Australia/Sydney',
    'Australia/Tasmania': 'Australia/Tasmania',
    'Australia/Victoria': 'Australia/Victoria',
    'Australia/West': 'Australia/West',
    'Australia/Yancowinna': 'Australia/Yancowinna',
    'Brazil/Acre': 'Brazil/Acre',
    'Brazil/DeNoronha': 'Brazil/DeNoronha',
    'Brazil/East': 'Brazil/East',
    'Brazil/West': 'Brazil/West',
    'CET': 'CET',
    'CST6CDT': 'CST6CDT',
    'Canada/Atlantic': 'Canada/Atlantic',
    'Canada/Central': 'Canada/Central',
    'Canada/Eastern': 'Canada/Eastern',
    'Canada/Mountain': 'Canada/Mountain',
    'Canada/Newfoundland': 'Canada/Newfoundland',
    'Canada/Pacific': 'Canada/Pacific',
    'Canada/Saskatchewan': 'Canada/Saskatchewan',
    'Canada/Yukon': 'Canada/Yukon',
    'Chile/Continental': 'Chile/Continental',
    'Chile/EasterIsland': 'Chile/EasterIsland',
    'Cuba': 'Cuba',
    'EET': 'EET',
    'EST': 'EST',
    'EST5EDT': 'EST5EDT',
    'Egypt': 'Egypt',
    'Eire': 'Eire',
    'Etc/GMT': 'Etc/GMT',
    'Etc/GMT+0': 'Etc/GMT+0',
    'Etc/GMT+1': 'Etc/GMT+1',
    'Etc/GMT+10': 'Etc/GMT+10',
    'Etc/GMT+11': 'Etc/GMT+11',
    'Etc/GMT+12': 'Etc/GMT+12',
    'Etc/GMT+2': 'Etc/GMT+2',
    'Etc/GMT+3': 'Etc/GMT+3',
    'Etc/GMT+4': 'Etc/GMT+4',
    'Etc/GMT+5': 'Etc/GMT+5',
    'Etc/GMT+6': 'Etc/GMT+6',
    'Etc/GMT+7': 'Etc/GMT+7',
    'Etc/GMT+8': 'Etc/GMT+8',
    'Etc/GMT+9': 'Etc/GMT+9',
    'Etc/GMT-0': 'Etc/GMT-0',
    'Etc/GMT-1': 'Etc/GMT-1',
    'Etc/GMT-10': 'Etc/GMT-10',
    'Etc/GMT-11': 'Etc/GMT-11',
    'Etc/GMT-12': 'Etc/GMT-12',
    'Etc/GMT-13': 'Etc/GMT-13',
    'Etc/GMT-14': 'Etc/GMT-14',
    'Etc/GMT-2': 'Etc/GMT-2',
    'Etc/GMT-3': 'Etc/GMT-3',
    'Etc/GMT-4': 'Etc/GMT-4',
    'Etc/GMT-5': 'Etc/GMT-5',
    'Etc/GMT-6': 'Etc/GMT-6',
    'Etc/GMT-7': 'Etc/GMT-7',
    'Etc/GMT-8': 'Etc/GMT-8',
    'Etc/GMT-9': 'Etc/GMT-9',
    'Etc/GMT0': 'Etc/GMT0',
    'Etc/Greenwich': 'Etc/Greenwich',
    'Etc/UCT': 'Etc/UCT',
    'Etc/UTC': 'Etc/UTC',
    'Etc/Universal': 'Etc/Universal',
    'Etc/Zulu': 'Etc/Zulu',
    'Europe/Amsterdam': 'Europe/Amsterdam',
    'Europe/Andorra': 'Europe/Andorra',
    'Europe/Astrakhan': 'Europe/Astrakhan',
    'Europe/Athens': 'Europe/Athens',
    'Europe/Belfast': 'Europe/Belfast',
    'Europe/Belgrade': 'Europe/Belgrade',
    'Europe/Berlin': 'Europe/Berlin',
    'Europe/Bratislava': 'Europe/Bratislava',
    'Europe/Brussels': 'Europe/Brussels',
    'Europe/Bucharest': 'Europe/Bucharest',
    'Europe/Budapest': 'Europe/Budapest',
    'Europe/Busingen': 'Europe/Busingen',
    'Europe/Chisinau': 'Europe/Chisinau',
    'Europe/Copenhagen': 'Europe/Copenhagen',
    'Europe/Dublin': 'Europe/Dublin',
    'Europe/Gibraltar': 'Europe/Gibraltar',
    'Europe/Guernsey': 'Europe/Guernsey',
    'Europe/Helsinki': 'Europe/Helsinki',
    'Europe/Isle_of_Man': 'Europe/Isle_of_Man',
    'Europe/Istanbul': 'Europe/Istanbul',
    'Europe/Jersey': 'Europe/Jersey',
    'Europe/Kaliningrad': 'Europe/Kaliningrad',
    'Europe/Kiev': 'Europe/Kiev',
    'Europe/Kirov': 'Europe/Kirov',
    'Europe/Lisbon': 'Europe/Lisbon',
    'Europe/Ljubljana': 'Europe/Ljubljana',
    'Europe/London': 'Europe/London',
    'Europe/Luxembourg': 'Europe/Luxembourg',
    'Europe/Madrid': 'Europe/Madrid',
    'Europe/Malta': 'Europe/Malta',
    'Europe/Mariehamn': 'Europe/Mariehamn',
    'Europe/Minsk': 'Europe/Minsk',
    'Europe/Monaco': 'Europe/Monaco',
    'Europe/Moscow': 'Europe/Moscow',
    'Europe/Nicosia': 'Europe/Nicosia',
    'Europe/Oslo': 'Europe/Oslo',
    'Europe/Paris': 'Europe/Paris',
    'Europe/Podgorica': 'Europe/Podgorica',
    'Europe/Prague': 'Europe/Prague',
    'Europe/Riga': 'Europe/Riga',
    'Europe/Rome': 'Europe/Rome',
    'Europe/Samara': 'Europe/Samara',
    'Europe/San_Marino': 'Europe/San_Marino',
    'Europe/Sarajevo': 'Europe/Sarajevo',
    'Europe/Saratov': 'Europe/Saratov',
    'Europe/Simferopol': 'Europe/Simferopol',
    'Europe/Skopje': 'Europe/Skopje',
    'Europe/Sofia': 'Europe/Sofia',
    'Europe/Stockholm': 'Europe/Stockholm',
    'Europe/Tallinn': 'Europe/Tallinn',
    'Europe/Tirane': 'Europe/Tirane',
    'Europe/Tiraspol': 'Europe/Tiraspol',
    'Europe/Ulyanovsk': 'Europe/Ulyanovsk',
    'Europe/Uzhgorod': 'Europe/Uzhgorod',
    'Europe/Vaduz': 'Europe/Vaduz',
    'Europe/Vatican': 'Europe/Vatican',
    'Europe/Vienna': 'Europe/Vienna',
    'Europe/Vilnius': 'Europe/Vilnius',
    'Europe/Volgograd': 'Europe/Volgograd',
    'Europe/Warsaw': 'Europe/Warsaw',
    'Europe/Zagreb': 'Europe/Zagreb',
    'Europe/Zaporozhye': 'Europe/Zaporozhye',
    'Europe/Zurich': 'Europe/Zurich',
    'GB': 'GB',
    'GB-Eire': 'GB-Eire',
    'GMT': 'GMT',
    'GMT+0': 'GMT+0',
    'GMT-0': 'GMT-0',
    'GMT0': 'GMT0',
    'Greenwich': 'Greenwich',
    'HST': 'HST',
    'Hongkong': 'Hongkong',
    'Iceland': 'Iceland',
    'Indian/Antananarivo': 'Indian/Antananarivo',
    'Indian/Chagos': 'Indian/Chagos',
    'Indian/Christmas': 'Indian/Christmas',
    'Indian/Cocos': 'Indian/Cocos',
    'Indian/Comoro': 'Indian/Comoro',
    'Indian/Kerguelen': 'Indian/Kerguelen',
    'Indian/Mahe': 'Indian/Mahe',
    'Indian/Maldives': 'Indian/Maldives',
    'Indian/Mauritius': 'Indian/Mauritius',
    'Indian/Mayotte': 'Indian/Mayotte',
    'Indian/Reunion': 'Indian/Reunion',
    'Iran': 'Iran',
    'Israel': 'Israel',
    'Jamaica': 'Jamaica',
    'Japan': 'Japan',
    'Kwajalein': 'Kwajalein',
    'Libya': 'Libya',
    'MET': 'MET',
    'MST': 'MST',
    'MST7MDT': 'MST7MDT',
    'Mexico/BajaNorte': 'Mexico/BajaNorte',
    'Mexico/BajaSur': 'Mexico/BajaSur',
    'Mexico/General': 'Mexico/General',
    'NZ': 'NZ',
    'NZ-CHAT': 'NZ-CHAT',
    'Navajo': 'Navajo',
    'PRC': 'PRC',
    'PST8PDT': 'PST8PDT',
    'Pacific/Apia': 'Pacific/Apia',
    'Pacific/Auckland': 'Pacific/Auckland',
    'Pacific/Bougainville': 'Pacific/Bougainville',
    'Pacific/Chatham': 'Pacific/Chatham',
    'Pacific/Chuuk': 'Pacific/Chuuk',
    'Pacific/Easter': 'Pacific/Easter',
    'Pacific/Efate': 'Pacific/Efate',
    'Pacific/Enderbury': 'Pacific/Enderbury',
    'Pacific/Fakaofo': 'Pacific/Fakaofo',
    'Pacific/Fiji': 'Pacific/Fiji',
    'Pacific/Funafuti': 'Pacific/Funafuti',
    'Pacific/Galapagos': 'Pacific/Galapagos',
    'Pacific/Gambier': 'Pacific/Gambier',
    'Pacific/Guadalcanal': 'Pacific/Guadalcanal',
    'Pacific/Guam': 'Pacific/Guam',
    'Pacific/Honolulu': 'Pacific/Honolulu',
    'Pacific/Johnston': 'Pacific/Johnston',
    'Pacific/Kiritimati': 'Pacific/Kiritimati',
    'Pacific/Kosrae': 'Pacific/Kosrae',
    'Pacific/Kwajalein': 'Pacific/Kwajalein',
    'Pacific/Majuro': 'Pacific/Majuro',
    'Pacific/Marquesas': 'Pacific/Marquesas',
    'Pacific/Midway': 'Pacific/Midway',
    'Pacific/Nauru': 'Pacific/Nauru',
    'Pacific/Niue': 'Pacific/Niue',
    'Pacific/Norfolk': 'Pacific/Norfolk',
    'Pacific/Noumea': 'Pacific/Noumea',
    'Pacific/Pago_Pago': 'Pacific/Pago_Pago',
    'Pacific/Palau': 'Pacific/Palau',
    'Pacific/Pitcairn': 'Pacific/Pitcairn',
    'Pacific/Pohnpei': 'Pacific/Pohnpei',
    'Pacific/Ponape': 'Pacific/Ponape',
    'Pacific/Port_Moresby': 'Pacific/Port_Moresby',
    'Pacific/Rarotonga': 'Pacific/Rarotonga',
    'Pacific/Saipan': 'Pacific/Saipan',
    'Pacific/Samoa': 'Pacific/Samoa',
    'Pacific/Tahiti': 'Pacific/Tahiti',
    'Pacific/Tarawa': 'Pacific/Tarawa',
    'Pacific/Tongatapu': 'Pacific/Tongatapu',
    'Pacific/Truk': 'Pacific/Truk',
    'Pacific/Wake': 'Pacific/Wake',
    'Pacific/Wallis': 'Pacific/Wallis',
    'Pacific/Yap': 'Pacific/Yap',
    'Poland': 'Poland',
    'Portugal': 'Portugal',
    'ROC': 'ROC',
    'ROK': 'ROK',
    'Singapore': 'Singapore',
    'Turkey': 'Turkey',
    'UCT': 'UCT',
    'US/Alaska': 'US/Alaska',
    'US/Aleutian': 'US/Aleutian',
    'US/Arizona': 'US/Arizona',
    'US/Central': 'US/Central',
    'US/East-Indiana': 'US/East-Indiana',
    'US/Eastern': 'US/Eastern',
    'US/Hawaii': 'US/Hawaii',
    'US/Indiana-Starke': 'US/Indiana-Starke',
    'US/Michigan': 'US/Michigan',
    'US/Mountain': 'US/Mountain',
    'US/Pacific': 'US/Pacific',
    'US/Samoa': 'US/Samoa',
    'UTC': 'UTC',
    'Universal': 'Universal',
    'W-SU': 'W-SU',
    'WET': 'WET',
    'Zulu': 'Zulu',
});

const USATimeZones = new Enum({
    'US/Alaska': 'US/Alaska',
    'US/Aleutian': 'US/Aleutian',
    'US/Arizona': 'US/Arizona',
    'US/Central': 'US/Central',
    'US/East-Indiana': 'US/East-Indiana',
    'US/Eastern': 'US/Eastern',
    'US/Hawaii': 'US/Hawaii',
    'US/Indiana-Starke': 'US/Indiana-Starke',
    'US/Michigan': 'US/Michigan',
    'US/Mountain': 'US/Mountain',
    'US/Pacific': 'US/Pacific',
    'US/Samoa': 'US/Samoa',
});

const Genders = new Enum({
    FEMALE: 'Female',
    MALE: 'Male',
    UNKNOWN: 'Unknown',
});

const Races = new Enum({
    AMERICAN_INDIAN_ALASKAN_NATIVE: 'American Indian/Alaskan Native',
    ASIAN: 'Asian',
    BLACK_AFRICAN_AMERICAN: 'Black/African-American',
    HAWAIIAN_PACIFIC_ISLANDER: 'Hawaiian/Pacific Islander',
    MIDDLE_EASTERN_NORTH_AFRICAN: 'Middle Eastern or North African Decent',
    WHITE_CAUCASIAN: 'White/Caucasian',
    UNKNOWN: 'Unknown',
    OTHER: 'Other',
});

const Ethnicities = new Enum({
    HISPANIC_LATINO: 'Hispanic/Latino',
    NON_HISPANIC_LATINO: 'Non-Hispanic/Latino',
    UNKNOWN: 'Unknown',
});

const PrimaryMemberRelationships = new Enum({
    MEMBER: 'Member',
    UNKNOWN: 'Unknown',
    SPOUSE: 'Spouse',
    CHILD: 'Child',
    EMPLOYEE: 'Employee',
    ORGAN_DONOR: 'Organ Donor',
    CADAVER_DONOR: 'Cadaver Donor',
    LIFE_PARTNER: 'Life Partner',
    OTHER: 'Other',
});

const PatientRelationshipToSubscribers = new Enum({
    0: 'MEMBER',
    1: 'UNKNOWN',
    2: 'SPOUSE',
    3: 'CHILD',
    4: 'EMPLOYEE',
    5: 'ORGAN_DONOR',
    6: 'CADAVER_DONOR',
    7: 'LIFE_PARTNER',
    8: 'OTHER',
});

const InsuranceRanks = new Enum({
    PRIMARY: 'Primary Insurance',
    SECONDARY: 'Secondary Insurance',
    TERTIARY: 'Tertiary Insurance',
    SUPPLEMENTAL: 'Supplemental Insurance',
    OTHER: 'Other',
    EXPIRED: 'Expired',
    UNKNOWN: 'Unknown',
});

const InsuranceStatuses = new Enum({
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    'INACTIVE (PART A)': 'Part B Only',
    'INACTIVE (PART B)': 'Part A Only',
    REJECTED: 'Rejected',
    CONTACT_PAYER: 'Contact Payer',
    UNKNOWN: 'Unknown',
});

const OrderStatuses = new Enum({
    DRAFT: 'Draft', // Draft order created when customers start the checkout process
    CONFIRMED: 'Patient Confirmed', // Patient Confirmed the order
    APPROVED: 'Provider Approved', // Provider Approved the order
    DENIED: 'Provider Denied',
    READY: 'Ready for Billing', // Order is Confirmed, Approved, and has a valid payment method attached in the payment details
    PENDING: 'Pending', // Order received, no payment initiated. Awaiting payment (unpaid). Hasn't been sent to shipment facility to be processed yet.
    PROCESSING: 'Processing', // Payment received (paid) and stock has been reduced; order is awaiting fulfillment. All product orders require processing, except those that only contain products which are both virtual and downloadable
    PROCESSING_CREATED: 'Created for Fulfillment',
    PROCESSING_SUBMITTED: 'Submitted for Fulfillment',
    PROCESSING_RECEIVED: 'Received for Fulfillment',
    PROCESSING_QUEUED: 'Queued for Fulfillment',
    PROCESSING_PREVERIFICATION: 'Pre-Verification for Fulfillment',
    PROCESSING_FILLING: 'Filling',
    PROCESSING_VERIFIED: 'Fulfillment is Verified',
    PROCESSING_FILLED: 'Filled',
    PROCESSING_EXCEPTION: 'Fulfillment Issue', // a problem at the pharmacy, before the shipment exists
    SHIPMENT_CREATED: 'Shipment Label Created',
    SHIPMENT_SHIPPED: 'Shipment Has Shipped',
    SHIPMENT_DELIVERED: 'Shipment Has Been Delivered',
    SHIPMENT_CANCELLED: 'Shipment Has Been Cancelled',
    ON_HOLD: 'On Hold',
    EXCEPTION: 'Exception', // a problem with the shipment after it left the pharmacy (carrier exception, failed delivery, return to sender); the name predates PROCESSING_EXCEPTION and is kept for history
    PARTIALLY_FULFILLED: 'Partially Fulfilled', // Part of the order is completed but not all of it
    COMPLETED: 'Completed', // Order fulfilled and complete – requires no further action. Paid has been received as well.
    CANCELLED: 'Cancelled', // Cancelled by an admin or the customer – stock is increased, no further action required. Please note: This status does not refund the customer. An example use case: The merchant wants to cancel the order because the customer has become unresponsive and they do not know where to ship the product. The customer is not eligible for a refund in this case.
    REFUNDED: 'Refunded', // Refunded by an admin – no further action required.
    AUTHENTICATION_REQUIRED: 'Authentication Required', // Awaiting action by the customer to authenticate the transaction and/or complete SCA requirements.
    FAILED: 'Failed Payment', // Payment failed or was declined (unpaid) or requires authentication (SCA). Note that this status may not show immediately and instead show as Pending until verified (e.g., PayPal).
    COLLECTIONS: 'Payment Collections', // Order is in collections due to non-payment
    SKIPPED: 'Skipped',
    DISQUALIFIED: 'Disqualified', // Customer order is disqualified because requirements for products in the order or responses to intake forms make them ineligible to receive product
    MEDICATION_UNAVAILABLE: 'Medication is Unavailable',
    ALTERNATIVE: 'Alternative Prescription Order',
    ALTERNATIVE_SUBMITTED: 'Alternative Prescription Order - Submitted',
    ALTERNATIVE_PROCESSING: 'Alternative Prescription Order - Processing',
    ALTERNATIVE_UNAVAILABLE: 'Alternative Prescription Order - Medication is Unavailable',
    ALTERNATIVE_EXCEPTION: 'Alternative Prescription Order - Exception',
    MEDICATION_CHANGE: 'Medication Change - Actions Needed',
    CLOSED: 'Completed and Paid For',
});

const OrderTypes = new Enum({
    ORDER: 'Standard/First Order',
    RENEWAL: 'Renewal Order', // Renewal Orders are normally created automatically on the subscription’s predefined billing schedule. They can be used to record either an automatic or manual recurring payment. Or no payment at all, in the case of subscriptions with a $0 total. Importantly, a subscription can have multiple Renewal Orders associated with it, as multiple recurring payments may have been processed during its life-cycle. For example, a monthly subscription that has been active for 12 months will have 11 Renewal Orders.
    RESUBSCRIBE: 'Resubscribe Order', // If a customer wants to extend an expired subscription, or resume a previously cancelled subscription, she can resubscribe to the subscription. The resubscribe process takes the customer through the normal cart and checkout flow to complete sign-up on the subscription. As part of this flow, an order is created to record the transaction. This order is both a Resubscribe Order, as it records the resubscribe action, and a Parent Order, as a new subscription is created to continue the old subscription’s terms. A Resubscribe Order is linked to both the old subscription which is being resubscribed to, and the new subscription being created to continue the old subscriptions terms. This means a subscription can have up to two Resubscribe Orders associated with it – one to record its creation, if it was created by resubscribing to another subscription, and one to record a new subscription created from its terms after it expired or was cancelled.
    SWITCH: 'Switch Order', // When a customer upgrades or downgrades their subscription, the switch process takes the customer through the normal cart and checkout flow to complete the transaction. As part of this flow, an order is created to record the upgrade or downgrade transaction. As this order records the switch transaction, it is linked to the subscription using a relationship referred to as a Switch Order. In some cases, the Switch Order will also be a Parent Order, as when the new subscription's schedule does not align to existing products on the existing subscription, a new subscription will be created. Importantly, a subscription can have multiple Switch Orders associated with it, as a customer can upgrade or downgrade the same subscription multiple times in different transactions.
    PARENT: 'Parent Order', // The parent order for a subscription records the creation of the subscription. Normally, this is a record of a subscription product being purchased. Importantly, a subscription can only ever have one Parent Order. A subscription can only ever be created once, so it only needs one Parent Order to record that transaction. On the other hand, one Parent Order can be related to multiple subscriptions, because it’s possible to purchase different subscription products in the same transaction. However, a subscription will not always have a Parent Order if the subscription is created manually.
    REFUND: 'Refund Order', // Used to track a refund
    VOUCHER: 'Voucher Order', // An order for the sole purpose of purchasing vouchers
    PRESCRIPTION: 'Prescription Order', // An order for a prescription
});

const SubscriptionStatuses = new Enum({
    PENDING: 'Pending',
    ACTIVE: 'Active',
    ON_HOLD: 'On Hold',
    EXPIRED: 'Expired',
    CANCELLED: 'Cancelled',
    PENDING_CANCEL: 'Pending Cancellation',
    DENIED: 'Provider Denied',
    PAUSED: 'Paused',
    SUSPENDED: 'Temporarily On Hold due to Non-Payment',
    PHARMACY_CHANGED: 'Pharmacy Changed'
});

const Suffixes = new Enum({
    JR: 'Jr.',
    SR: 'Sr.',
    II: 'II',
    III: 'III',
    IV: 'IV',
    V: 'V',
    VI: 'VI',
    VII: 'VII',
});

const LeadStatuses = new Enum({
    CREATED: 'Created',
    PENDING: 'Submitted without S/O/E',
    SUBMITTED: 'Submitted with CC Auth',
    SUBMITTED_WITH_CONTACT_PAYER: 'Opted-In with a Contact Payer Insurance',
    SUBMITTED_WITH_INACTIVE: 'Opted-In with an Inactive Insurance',
    REQUESTED_SUPPORT_CALL: 'Opted-In but Support Call Needed',
    SUBMITTED_WITH_ERROR: 'Submitted with an Error',
    IMPORTED: 'Subscription Approved',
    DUPLICATE: 'Duplicate Patient',
    ON_HOLD: 'On Hold Due to Insurance',
    FRAUD: 'Suspected Fraud',
    OPTED_OUT: 'Patient Opted Out',
    NOT_INTERESTED: 'Patient Not Interested',
    INELIGIBLE: 'Ineligible Insurance',
    DENIED: 'Provider Denied',
    DISQUALIFIED: 'Disqualified', // Customer order is disqualified because requirements for products in the order or responses to intake forms make them ineligible to receive product
    CANCELLED: 'Patient Cancelled',
});

const PlanTypes = new Enum({
    MEDICARE: 'Medicare',
    'MEDICARE ADVANTAGE': 'Medicare Advantage',
    SUPPLEMENTAL: 'Supplemental (Secondary to Medicare Coverage)',
    DUAL: 'Dual Medicare/Medicaid',
    'MEDICAID MCO': 'Medicaid MCO',
    MEDICAID: 'Medicaid',
    COMMERCIAL: 'Commercial',
    IPA: 'IPA (Independent Practitioner Association or Medical Group Plan)',
    OTHER: 'Other',
});

const ShipmentStatuses = new Enum({
    PENDING: 'Pending', // The order has been placed but has not yet been processed for shipping.
    PROCESSING: 'Processing', // The order is being prepared for shipment. This status typically includes activities such as picking and packing the items, generating shipping labels, and arranging for carrier pickup.
    LABEL_CREATED: 'Label Created', // A shipping label has been generated for the order, but the package has not yet been handed over to the carrier. This status indicates that the order is ready for shipment but is still in the fulfillment center or warehouse.
    SHIPPED: 'Shipped', // The order has been handed over to the shipping carrier for delivery to the customer. At this stage, you may provide additional details such as the tracking number and carrier information.
    IN_TRANSIT: 'In Transit', // The order is en route to the customer's designated delivery address. This status indicates that the shipment is in progress and moving through various transit points.
    OUT_FOR_DELIVERY: 'Out for Delivery', // The shipment is out for delivery and is expected to be delivered to the customer soon. This status is typically used when the package is with the local delivery carrier or driver.
    DELIVERED_TO_AGENT: 'Delivered to Agent',
    ATTEMPTED_DELIVERY: 'Delivery Attempted',
    AVAILABLE_FOR_PICKUP: 'Available for Pickup',
    AVAILABLE_FOR_AGENT_PICKUP: 'Available for Agent Pickup',
    PREPARED_FOR_DELIVERY: 'Prepared for Re-Delivery',
    PICKED_UP: 'Picked Up',
    DELIVERED: 'Delivered', // The shipment has been successfully delivered to the customer's specified address and has been received and signed for, or marked as delivered by the carrier.
    FAILED: 'Failed Delivery', // The delivery attempt was unsuccessful due to various reasons such as an incorrect address, recipient unavailability, or other delivery issues. This status may require further action, such as scheduling a new delivery attempt or contacting the customer for updated information.
    RETURNED: 'Returned', // The shipment has been returned to the sender for reasons such as failed delivery attempts, customer refusal, or incorrect address. This status indicates that the package is back in the possession of the seller and may require further action, such as processing a refund or resending the package.
    CANCELLED: 'Cancelled', // The order or shipment has been canceled before or during the shipping process. This status is typically used when the customer or the seller initiates a cancellation request.
    ON_HOLD: 'Shipment is On Hold', // The order requires further verification or action before proceeding with shipment.
    EXCEPTION: 'Shipment Exception', // The shipment cannot be fulfilled due to an out of stock or inactive product.
    VOIDED: 'Label Voided', // The shipping label has been voided or canceled before the shipment was processed. Will likely have a new label created.
});

const BillingStatuses = new Enum({
    PENDING: 'Pending',
    SENT_TO_BILLING: 'Sent to Billing',
    APPROVED: 'Approved for Reimbursement',
    REJECTED: 'Rejected for Reimbursement',
    SKIPPED: 'Skip This Order',
    APPEALED: 'Appealed with Insurance',
    PAID: 'Reimbursement Paid',
});

const SubscriptionBillingPeriods = new Enum({
    DAY: 'Day',
    WEEK: 'Week',
    MONTH: 'Month',
    YEAR: 'Year',
});

const LeadEmailTemplates = new Enum({
    LEAD_CANCEL: 'Lead Opt-Out Email',
    LEAD_ACCEPTED_INSURANCE_WELCOME: 'Lead Accepted Insurance Opt-In Welcome Email',
    LEAD_OTHER_INSURANCE_WELCOME: 'Lead On-Hold Other Insurance Opt-In Welcome Email',
    LEAD_IMPORTED: 'Lead Imported as Patient with Good Insurance Email',
    LEAD_NEED_MORE_INFO: 'Lead Need More Info to Find Insurance Email',
    LEAD_NEED_MORE_INFO_INACTIVE: 'Lead Need More Info to Find Insurance Because Insurance Is Inactive Email',
});

const OrderEmailTemplates = new Enum({
    CUSTOMER_ORDER_FIRST_APPROVED: 'Email When a Customer Is Approved By Insurance for Their First Order (Do not send for later orders)',
    CUSTOMER_ORDER_SHIPPED: 'Email When an Order Has Shipped',
    CUSTOMER_ORDER_APPEALED_SKIPPED: 'Email When Insurance Is Being Appealed or Order Is Being Skipped',
    CUSTOMER_ORDER_REJECTED: 'Email When Insurance Has Fully Rejected Claim for Order',
    CUSTOMER_SUBSCRIPTION_CANCELLED: 'Email When a Customer Has Opted Out of Their Subscription',
});

// the only enum here whose value is a collection name rather than a display label: a caller holding an
// entityType resolves its collection through it instead of keeping a private map. the collection cannot be
// derived from the key - cancellationRequests is camelCase, not a lowercase plural - which is exactly why
// the mapping is declared once, and toFormattedString('EntityType', key) answers with the collection name
// too - which is the point: the collection is what an operator wants to see for an entityType.
const EntityTypes = new Enum({
    USER: 'users',
    LEAD: 'leads',
    ORDER: 'orders',
    SUBSCRIPTION: 'subscriptions',
    ENCOUNTER: 'encounters',
    TASK: 'tasks',
    PRESCRIPTION: 'prescriptions',
    CANCELLATION_REQUEST: 'cancellationRequests',
    PROGRAM: 'programs',
    PRODUCT_FAMILY: 'productFamilies',
    PRODUCT: 'products',
});

const CoveredEntityTypes = new Enum({
    DOCTOR: 'Doctor',
    CLINIC: 'Clinic',
    PSYCHOLOGIST: 'Psychologist',
    DENTIST: 'Dentist',
    CHIROPRACTOR: 'Chiropractor',
    NURSING_HOME: 'Nursing Home',
    PHARMACY: 'Pharmacy',
    LABORATORY: 'Laboratory',
    PRACTICE: 'Physician Practice',
});

const PolicyTypes = new Enum({
    PPO: 'Preferred Provider Organization (PPO)',
    HMO: 'Health Maintenance Organization (HMO)',
    EPO: 'Exclusive Provider Organization (EPO)',
    POS: 'Point-of-Service Plan (POS)',
    HDHP: 'High-Deductible Health Plan (HDHP)',
    FFS: 'Fee-For-Service Plan (FFS)',
    CDHP: 'Consumer-Driver Health Plan (CDHP)',
    HRA: 'Health Reimbursement Arrangement (HRA)',
    HSA: 'Health Savings Account (HSA)',
    FSA: 'Flexible Spending Account (FSA)',
});

const SelfIdentifiedGenders = new Enum({
    FEMALE: 'Female',
    MALE: 'Male',
    NON_BINARY: 'Non-binary',
    TRANSGENDER: 'Transgender',
    INTERSEX: 'Intersex',
    NO_ANSWER: 'Prefer Not to Answer',
});

const AgeCategories = new Enum({
    YO0_9: '0 - 9 Years Old',
    YO10_19: '10 - 19 Years Old',
    YO20_29: '20 - 29 Years Old',
    YO30_39: '30 - 39 Years Old',
    YO40_49: '40 - 49 Years Old',
    YO50_59: '50 - 59 Years Old',
    YO60_69: '60 - 69 Years Old',
    YO70_79: '70 - 79 Years Old',
    YO80_89: '80 - 89 Years Old',
    YO90_UP: '90+ Years Old',
});

const SelfIdentifiedRaces = new Enum({
    AMERICAN_INDIAN_ALASKAN_NATIVE: 'American Indian/Alaskan Native',
    ASIAN: 'Asian',
    BLACK_AFRICAN_AMERICAN: 'Black/African-American',
    HAWAIIAN_PACIFIC_ISLANDER: 'Hawaiian/Pacific Islander',
    MIDDLE_EASTERN_NORTH_AFRICAN: 'Middle Eastern or North African Decent',
    WHITE_CAUCASIAN: 'White/Caucasian',
    OTHER: 'Other',
    NO_ANSWER: 'Prefer Not to Answer',
});

const SelfIdentifiedEthnicities = new Enum({
    HISPANIC_LATINO: 'Hispanic/Latino',
    NON_HISPANIC_LATINO: 'Non-Hispanic/Latino',
    NO_ANSWER: 'Prefer Not to Answer',
});

const CovidTestingReasons = new Enum({
    EXPOSURE: 'Exposure to COVID-19',
    SYMPTOMS: 'Signs and Symptoms',
    EMPLOYER: 'Employer/Agency Recommended Testing',
    TRAVEL: 'Travel Requirement',
    NOT_NECESSITY: 'Not a Necessity',
    OTHER: 'Other',
});

const CovidSymptoms = new Enum({
    COUGH: 'Cough',
    SORE_THROAT: 'Sore throat',
    CHILLS: 'Chills',
    DIARRHEA: 'Diarrhea',
    FEVER: 'Fever',
    FATIGUE: 'Tiredness/fatigue',
    HEADACHE: 'Headache',
    DIFFICULTY_BREATHING: 'Difficulty breathing',
    ACHES: 'Muscle or body aches',
    LOSS_OF_TASTE_SMELL: 'Loss of taste and/or smell',
    NAUSEA: 'Nausea',
    VOMITING: 'Vomiting',
    OTHER: 'Other',
    NO_SYMPTOMS: 'No Symptoms',
});

const YesNoNoAnswer = new Enum({
    YES: 'Yes',
    NO: 'No',
    NO_ANSWER: 'Prefer Not to Answer',
});

const CovidVaccinationStatuses = new Enum({
    YES_BOOSTERS: 'Yes, booster(s)',
    YES_PARTIAL: 'Yes, a partial series',
    YES_COMPLETE: 'Yes, a complete series',
    NO: 'No vaccination',
    NO_ANSWER: 'Prefer Not to Answer',
});

const MessageStatuses = new Enum({
    ACCEPTED: 'Accepted',
    SCHEDULED: 'Scheduled',
    QUEUED: 'Queued',
    SENDING: 'Sending',
    SENT: 'Sent',
    DELIVERY_UNKNOWN: 'Delivery Unknown',
    DELIVERED: 'Delivered',
    UNDELIVERED: 'Undelivered',
    FAILED: 'Failed',
    RECEIVED: 'Received'
});

const MessageDirections = new Enum({
    INCOMING: 'Incoming',
    OUTGOING: 'Outgoing',
});

const ActivityTypes = new Enum({
    EMAIL: 'Email',
    SMS: 'Text Message',
    CALL: 'Call',
    FACE: 'Person to Person',
    NONE: 'No Contact',
});

const ActivityDirections = new Enum({
    INCOMING: 'Incoming',
    OUTGOING: 'Outgoing',
});

const CoveredEntityRoles = new Enum({
    ADMIN: 'Account Administrator',
    PROVIDER: 'Provider',
    CLINICIAN: 'Clinician',
});

const AffiliateRoles = new Enum({
    ADMIN: 'Account Administrator',
    MANAGER: 'Manager',
});

const PartnerRoles = new Enum({
    ADMIN: 'Account Administrator',
    MANAGER: 'Manager',
    PATIENT: 'Patient',
});

const DocumentTypes = new Enum({
    COVERED_ENTITY_LOGO: 'Covered Entity Logo',
    PROFILE_PICTURE: 'Profile Picture',
    VACCINATION_CARD: 'Vaccination Card',
    DRIVERS_LICENSE_FRONT: 'Drivers License - Front',
    DRIVERS_LICENSE_BACK: 'Drivers License - Back',
    PASSPORT: 'Passport',
    SOCIAL_SECURITY_CARD: 'Social Security Card',
    BIRTH_CERTIFICATE: 'Birth Certificate',
    TEST_RESULTS: 'Test Results',
    INSURANCE_CARD_FRONT: 'Insurance Card - Front',
    INSURANCE_CARD_BACK: 'Insurance Card - Back',
    OTHER: 'Other',
});

const PatientDocumentTypes = new Enum({
    PROGRESS_PICTURE: 'Progress Picture',
    MEDICATION: 'Picture of Medication Bottle',
    VACCINATION_CARD: 'Vaccination Card',
    DRIVERS_LICENSE_FRONT: 'Drivers License - Front',
    DRIVERS_LICENSE_BACK: 'Drivers License - Back',
    PASSPORT: 'Passport',
    SOCIAL_SECURITY_CARD: 'Social Security Card',
    BIRTH_CERTIFICATE: 'Birth Certificate',
    TEST_RESULTS: 'Test Results',
    INSURANCE_CARD_FRONT: 'Insurance Card - Front',
    INSURANCE_CARD_BACK: 'Insurance Card - Back',
    OTHER: 'Other',
});

const DocumentReviewStatuses = new Enum({
    PENDING: 'Pending',
    VERIFIED: 'Verified',
});

const ProductStatuses = new Enum({
    DRAFT: 'Draft',
    PUBLISHED: 'Published',
    ON_DEMAND: 'On Demand',
    UNPUBLISHED: 'Unpublished',
    DELETED: 'Deleted',
});

const StockStatuses = new Enum({
    IN_STOCK: 'In Stock',
    OUT_OF_STOCK: 'Out of Stock',
});

const TaxStatuses = new Enum({
    TAXABLE: 'Product and shipping are both taxable',
    PRODUCT_ONLY: 'Only product is taxable',
    SHIPPING_ONLY: 'Only shipping is taxable',
    NONE: 'None',
});

const SubscriptionLimits = new Enum({
    NONE: 'No Limit',
    ONE_ACTIVE: 'Limit to One Active Subscription',
    ONE_LIFETIME: 'Limit to One of Any Status',
});

const ProductTypes = new Enum({
    SIMPLE: 'Standard Product',
    SUBSCRIPTION: 'Standard Product Subscription',
    SERVICE: 'Service',
    VARIABLE: 'Variable Product',
    TEST: 'Test Kit/Panel',
    TEST_SUBSCRIPTION: 'Test Subscription',
    VACCINATION: 'Vaccination',
    VACCINATION_SUBSCRIPTION: 'Vaccination Subscription',
    TELEHEALTH: 'Telehealth Visit',
    PRESCRIPTION: 'Prescription Product',
    PRESCRIPTION_SUBSCRIPTION: 'Prescription Subscription Product',
    STACKED: 'Stacked (Bundle of Products) Product',
    STACKED_SUBSCRIPTION: 'Stacked (Bundle of Products) Subscription Product',
    ADD_ON: 'Add-On Product',
});

const AddOnQuantityModes = new Enum({
    FIXED: 'Fixed Quantity',
    PER_UNIT: 'Per Unit of Triggering Product',
    PER_LINE_ITEM: 'Per Line Item',
});

const AddOnScopes = new Enum({
    PER_PRODUCT: 'Per Product',
    PER_SHIPMENT: 'Per Shipment',
});

const AddOnShipmentQuantityModes = new Enum({
    MAX: 'Maximum (Use Highest Quantity)',
    SUM: 'Sum (Add All Quantities)',
});

const AddOnSources = new Enum({
    PRODUCT_RULE: 'Product Rule',
    SUPPLIER_MAPPING: 'Supplier Mapping Override',
});

const EmailSources = new Enum({
    CONTACT_FORM: 'Contact Form',
    GMAIL: 'Gmail',
    CUSTOMER_IO: 'Customer.io',
    SENDGRID: 'SendGrid',
});

const EmailDeliveryStatuses = new Enum({
    SENT: 'Sent',
    FAILED: 'Failed',
    DEFERRED: 'Deferred',
    DELIVERED: 'Delivered',
    BOUNCED: 'Bounced',
    DROPPED: 'Dropped',
});

const CommunicationChannels = new Enum({
    EMAIL: 'Email',
    SMS: 'SMS',
    CALL: 'Phone Call',
    PUSH: 'Push Notification',
});

// what the address check found for a shipping address. a state the program cannot ship to is an eligibility
// answer about a valid address, never one of these
const AddressVerificationStatuses = new Enum({
    VERIFIED: 'Verified',
    NON_POSTAL: 'Verified (not a USPS address)',
    NOT_FOUND: 'Not found, confirmed by customer',
    NOT_CHECKED: 'Not checked, confirmed by customer',
    MISSING_UNIT: 'Missing unit, confirmed by customer',
});

const CommunicationClassifications = new Enum({
    TRANSACTIONAL: 'Transactional',
    MARKETING: 'Marketing',
});

const CommunicationPreferenceEventActions = new Enum({
    CONSENT_GRANTED: 'Consent Granted',
    CONSENT_REVOKED: 'Consent Revoked',
    OPT_OUT: 'Opted Out',
    OPT_IN: 'Opted In',
    SMS_STOP: 'SMS STOP Received',
    SMS_START: 'SMS START Received',
    SPAM_REPORTED: 'Spam Report Received',
    DNC_SET: 'Do Not Call Set',
    DNC_CLEARED: 'Do Not Call Cleared',
    GLOBAL_MARKETING_OPT_OUT: 'Global Marketing Opt-Out',
    GLOBAL_MARKETING_OPT_IN: 'Global Marketing Opt-In',
    PREFERENCE_UPDATED: 'Preference Updated',
    IMPORTED: 'Imported',
});

const CommunicationPreferenceSources = new Enum({
    READYRX_ACCOUNT: 'ReadyRx Patient Account',
    READYRX_CHECKOUT: 'ReadyRx Checkout',
    READYRX_FUNNEL: 'ReadyRx Funnel or Lead Form',
    READYRX_ADMIN: 'ReadyRx Administration',
    READYRX_SUPPORT: 'ReadyRx Customer Support',
    CUSTOMER_IO: 'Customer.io',
    SENDGRID: 'SendGrid',
    OPTIZMO: 'OPTIZMO',
    TWILIO: 'Twilio',
    JUSTCALL: 'JustCall',
    ZOHO: 'Zoho',
    INTERCOM: 'Intercom',
    SYSTEM: 'ReadyRx System',
    IMPORT: 'Data Import',
    MIGRATION: 'Data Migration',
    UNKNOWN: 'Unknown',
});

// the two toll-free numbers each have one job, and JustCall numbers belong to a different provider
const SmsSenders = new Enum({
    MARKETING: 'Marketing number',
    TRANSACTIONAL: 'Transactional number',
    JUSTCALL: 'JustCall',
});

const WeightHistorySources = new Enum({
    FUNNEL: 'Funnel',
    CHECK_IN: 'Check-In',
    FOLLOW_UP: 'Follow-Up',
    MEAL_PLAN: 'Meal Plan',
    BACKFILL: 'Backfill',
});

// how a person came to be in an experiment arm - REQUESTED (?v=) shows a version but enrols nobody
const ExperimentAssignmentSources = new Enum({
    REQUESTED: 'Requested',
    RECORDED: 'Recorded',
    PINNED: 'Pinned',
    AUDIENCE: 'Audience',
    ALLOCATED: 'Allocated',
});

const EmailIngestionDispositions = new Enum({
    QUEUE: 'Queue',
    OPERATIONS_REVIEW: 'Operations Review',
    AUDIT_ONLY: 'Audit Only',
});

const EmailIngestionReasons = new Enum({
    DEFAULT: 'Default',
    IGNORED_SENDER: 'Ignored Sender',
    LEGACY_CONTACT_FORM_MIRROR: 'Legacy Contact Form Mirror',
});

const PendingMessageStatuses = new Enum({
    PENDING: 'Sending',
    FAILED: 'Not sent',
});

const GmailImportLogStatuses = new Enum({
    FAILED: 'Failed',
    SKIPPED: 'Skipped',
});

const GmailImportLogReasons = new Enum({
    PROCESSING_ERROR: 'Processing Error',
    GMAIL_NOT_FOUND: 'Gmail Not Found',
});

const OrderGroupStatuses = new Enum({
    CREATED: 'Created',
    PENDING: 'Pending',
    SUBMITTED: 'Submitted',
    PROCESSING: 'Processing',
    FILLED: 'Filled',
    SHIPPED: 'Shipped',
    DELIVERED: 'Delivered',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
    EXCEPTION: 'Exception',
});

const OrderGroupTypes = new Enum({
    STANDARD: 'Standard',
    GROUPED: 'Grouped',
});

const ShippingCalculationTypes = new Enum({
    ORDER: 'Per Order: Changes shipping for the most expensive option based on the shipping costs in the cart.',
    CLASS: 'Per Class: Charges shipping for each shipping class.',
});

const PaymentMethods = new Enum({
    CARD: 'Credit/Debit Card',
    ECHECK: 'E-Check',
    ACH: 'Electronic Bank Transfer via ACH',
    COD: 'Cash on Delivery',
    PRIMARY_INSURANCE: 'Primary Insurance',
    SECONDARY_INSURANCE: 'Secondary Insurance',
    TERTIARY_INSURANCE: 'Tertiary Insurance',
    CREDIT: 'Store Credit (Credit on Account)',
    VOUCHER: 'Voucher',
    UPCHARGE_VOUCHER: 'Upcharge Voucher',
    COMP: 'Complimentary Credit',
    KLARNA: 'Klarna',
    OTHER: 'Other',
});

const PaymentStatuses = new Enum({
    PENDING: 'Pending Invoicing',
    AUTHORIZED: 'Authorized Payment',
    INVOICED: 'Invoiced',
    RECEIVED: 'Received Payment but Processing',
    PAID: 'Paid',
    FAILED: 'Failed', // insurance was rejected or payment didnt go through
    CANCELLED: 'Cancelled',
    REFUNDED: 'Refunded',
});

const DiscountTypes = new Enum({
    FLAT_AMOUNT: 'Flat Amount Off',
    PERCENTAGE: 'Percentage Off',
});

const DiscountTargets = new Enum({
    CART: 'Discount is off the entire cart',
    PRODUCT: 'Discount is off specific product(s) only',
    SIGN_UP_FEE: 'Discount is off the sign-up fee',
    SHIPPING: 'Discount is off the shipping cost',
    RECURRING: 'Recurring discount off subscription products',
    BUNDLE: 'Paid-in-full discount off bundled orders',
    MIXED: 'Discount is off specific products but with product specific rules',
    MIXED_RECURRING: 'Recurring discount is off specific products but with product specific rules',
});

const CouponDiscountTargetTypes = new Enum({
    PRODUCT: 'Exact Product',
    COMMERCIAL_EQUIVALENCY_GROUP: 'Commercial Equivalency Group',
});

const CouponDiscountVariantScopes = new Enum({
    ALL: 'All Variants',
    SPECIFIC: 'Specific Variants',
});

const CommercialEquivalencyVariantMatchStrategies = new Enum({
    NONE: 'None',
    SAME_DISPLAY_ORDER: 'Same Display Order',
    SAME_STRENGTH: 'Same Strength',
    SAME_TITRATION_LEVEL: 'Same Titration Level',
});

const FunnelChoiceSetRenderModes = new Enum({
    PRODUCT_CARDS: 'Product Cards',
    PRODUCT_CARDS_WITH_SECTIONS: 'Product Cards with Sections',
    VARIANT_CARDS: 'Variant Cards',
});

const FunnelChoiceProductResolutionModes = new Enum({
    CANONICAL_BY_DISPLAY_ORDER: 'Canonical by Display Order',
    CUSTOMER_FORMULATION_STEP: 'Customer Formulation Step',
});

const FunnelChoiceDefaultVariantStrategies = new Enum({
    DISPLAY_ORDER: 'Display Order',
});

const MedicationTransitionSurveyReuseModes = new Enum({
    REUSE_COMPATIBLE_SURVEY: 'Reuse Compatible Survey',
});

const MedicationTransitionDoseStrategies = new Enum({
    MATCH_TITRATION_LEVEL: 'Match Titration Level',
    MATCH_DISPLAY_ORDER: 'Match Display Order',
    MATCH_STRENGTH: 'Match Strength',
});

const MedicationTransitionFutureBundleCountModes = new Enum({
    FLOOR_TO_SUPPORTED: 'Floor to Supported Bundle Count',
    LOWEST_SUPPORTED: 'Lowest Supported Bundle Count',
});

const MedicationTransitionScopeTypes = new Enum({
    PRODUCT: 'Product',
    COMMERCIAL_EQUIVALENCY_GROUP: 'Commercial Equivalency Group',
});

const MedicationTransitionLogStatuses = new Enum({
    STARTED: 'Started',
    VALIDATION_FAILED: 'Validation Failed',
    PAYMENT_FAILED: 'Payment Failed',
    COMPLETED: 'Completed',
    COMMIT_FAILED: 'Commit Failed',
    MANUAL_UNSAFE_STARTED: 'Manual Unsafe Change Started',
    MANUAL_UNSAFE_COMPLETED: 'Manual Unsafe Change Completed',
    MANUAL_UNSAFE_FAILED: 'Manual Unsafe Change Failed',
});

const MedicationTransitionTypes = new Enum({
    MANUAL_UNSAFE_PRODUCT_CHANGE: 'Manual Unsafe Product Change',
});

const DuplicateCheckScopes = new Enum({
    NONE: 'No Duplicate Check',
    PROGRAM: 'Current Program Only',
    ENROLLMENT_GROUP: 'Enrollment Group',
});

const DuplicateCheckModes = new Enum({
    ANY_ACTIVE: 'Any Active Enrollment Blocks',
    FAMILY_RULE: 'Product Family Rule',
});

const DuplicateBlockingStatuses = new Enum({
    CREATED: 'Created',
    PENDING: 'Pending',
    ACTIVE: 'Active',
    ON_HOLD: 'On Hold',
    PAUSED: 'Paused',
    PHARMACY_CHANGED: 'Pharmacy Changed',
    DENIED: 'Provider Denied',
});

const SurveyFlowKeys = new Enum({
    GOALS: 'Goals',
    INTAKE: 'Intake',
    CONSULT: 'Consult',
    FOLLOW_UP: 'Follow-Up',
});

const SurveyScopes = new Enum({
    USER: 'Per Patient',
    ORDER: 'Per Order',
    SUBSCRIPTION: 'Per Subscription',
    ENCOUNTER: 'Per Encounter',
    PRESCRIPTION: 'Per Prescription',
    LEAD: 'Per Lead',
    YEAR: 'Per Calendar Year',
});

const VaccinationStatuses = new Enum({
    UNAVAILABLE: 'No Record Available',
    UNVACCINATED: 'Unvaccinated',
    VACCINATED: 'Vaccinated',
    EXPIRED: 'Expired',
    NOT_ACCEPTED: 'Not Accepted',
    PARTIAL: 'Partially Vaccinated',
});

const VaccinationRequirements = new Enum({
    OPTIONAL: 'Optional',
    REQUIRED: 'Required',
});

const VaccinationTypes = new Enum({
    DOSAGE1: 'Dosage 1',
    DOSAGE2: 'Dosage 2',
    BOOSTER: 'Booster',
    SINGLE_DOSAGE: 'Single Dosage',
});

const TestStatuses = new Enum({
    UNAVAILABLE: 'No Results Available',
    PENDING: 'Pending',
    INCONCLUSIVE: 'Inconclusive',
    NEGATIVE: 'Negative',
    POSITIVE: 'Positive',
    EXPIRED: 'Expired',
    NOT_ACCEPTED: 'Not Accepted',
    UNTESTED: 'Untested',
});

const UserTestUserResults = new Enum({
    PENDING: 'Pending',
    NEGATIVE: 'Negative',
    POSITIVE: 'Positive',
    INCONCLUSIVE: 'Inconclusive',
});

const UserTestClinicianResults = new Enum({
    PENDING: 'Pending',
    UNVERIFIED: 'Unverified',
    NEGATIVE: 'Negative',
    POSITIVE: 'Positive',
    INCONCLUSIVE: 'Inconclusive',
});

const UserTestResultStatuses = new Enum({
    PENDING: 'Pending',
    PRELIMINARY: 'Preliminary',
    FINAL: 'Final',
});

const UserTestStatuses = new Enum({
    PENDING: 'Pending', // Test has been setup
    SHIPMENT_SHIPPED: 'Shipment Has Shipped', // Test has been shipped to customer
    SHIPMENT_DELIVERED: 'Shipment Has Been Delivered', // Test has been delivered to customer
    STARTED: 'Test Started',
    SUBMITTED: 'Test Results are Submitted By the Patient',
    COLLECTED: 'Test Specimen is Collected By the Lab',
    ASSIGNED: 'Test Assigned to Clinician',
    COMPLETED: 'Completed - Test Results Submitted By Clinician',
    CANCELLED: 'Cancelled',
    RETURN_SHIPMENT_SHIPPED: 'Return Shipment Has Shipped',
    RETURN_SHIPMENT_DELIVERED: 'Return Shipment Has Been Delivered',
    REQUISITION_CREATED: 'Requisition Created',
    APPOINTMENT_SCHEDULED: 'Appointment Scheduled',
    DRAW_COMPLETED: 'Specimen Draw Completed',
    PARTIAL_RESULTS: 'Partial Results Available',
    RESULTS_REVIEWED: 'Results Reviewed by Physician',
});

const TestSpecimens = new Enum({
    BLOOD: 'Blood',
    URINE: 'Urine',
    SALIVA: 'Saliva',
    MUCUS: 'Mucus',
    SKIN: 'Skin',
    TISSUE: 'Tissue',
    STOOL: 'Stool',
    DRIED_URINE: 'Dried Urine',
    BLOOD_AND_URINE: 'Blood and Urine',
});

const TransactionTypes = new Enum({
    SALE: 'Sale',
    AUTH: 'Authorization',
    CAPTURE: 'Capture',
    VOID: 'Void',
    REFUND: 'Refund',
    CREDIT: 'Credit',
    VALIDATE: 'Validate',
    OFFLINE: 'Offline',
});

const TransactionStatuses = new Enum({
    PENDING: '0 = Transaction Not Yet Submitted (Pending Submission to Gateway)',
    APPROVED: '1 = Transaction Approved',
    DECLINED: '2 = Transaction Declined',
    ERROR: '3 = Error in transaction data or system error',
});

const AVSResponseCodes = new Enum({
    X: 'Exact match, 9-character numeric ZIP',
    Y: 'Exact match, 5-character numeric ZIP',
    D: 'Exact match, 5-character numeric ZIP',
    M: 'Exact match, 5-character numeric ZIP',
    2: 'Exact match, 5-character numeric ZIP, customer name',
    6: 'Exact match, 5-character numeric ZIP, customer name',
    A: 'Address match only',
    B: 'Address match only',
    3: 'Address, customer name match only',
    7: 'Address, customer name match only',
    W: '9-character numeric ZIP match only',
    Z: '5-character ZIP match only',
    P: '5-character ZIP match only',
    L: '5-character ZIP match only',
    1: '5-character ZIP, customer name match only',
    5: '5-character ZIP, customer name match only',
    N: 'No address or ZIP match only',
    C: 'No address or ZIP match only',
    4: 'No address or ZIP or customer name match only',
    8: 'No address or ZIP or customer name match only',
    U: 'Address unavailable',
    G: 'Non-U.S. issuer does not participate',
    I: 'Non-U.S. issuer does not participate',
    R: 'Issuer system unavailable',
    E: 'Not a mail/phone order',
    S: 'Service not supported',
    0: 'AVS not available',
    O: 'AVS not available',
});

const CVVResponseCodes = new Enum({
    M: 'CVV2/CVC2 match',
    N: 'CVV2/CVC2 no match',
    P: 'Not processed',
    S: 'Merchant has indicated that CVV2/CVC2 is not present on card',
    U: 'Issuer is not certified and/or has not provided Visa encryption keys',
});

const TransactionResultCodes = new Enum({
    100: 'Transaction was approved.',
    200: 'Transaction was declined by processor.',
    201: 'Do not honor.',
    202: 'Insufficient funds.',
    203: 'Over limit.',
    204: 'Transaction not allowed.',
    220: 'Incorrect payment information.',
    221: 'No such card issuer.',
    222: 'No card number on file with issuer.',
    223: 'Expired card.',
    224: 'Invalid expiration date.',
    225: 'Invalid card security code.',
    226: 'Invalid PIN.',
    240: 'Call issuer for further information.',
    250: 'Pick up card.',
    251: 'Lost card.',
    252: 'Stolen card.',
    253: 'Fraudulent card.',
    260: 'Declined with further instructions available. (See response text)',
    261: 'Declined-Stop all recurring payments.',
    262: 'Declined-Stop this recurring program.',
    263: 'Declined-Update cardholder data available.',
    264: 'Declined-Retry in a few days.',
    300: 'Transaction was rejected by gateway.',
    301: 'Rate limit exceeded.',
    400: 'Transaction error returned by processor.',
    410: 'Invalid merchant configuration.',
    411: 'Merchant account is inactive.',
    420: 'Communication error.',
    421: 'Communication error with issuer.',
    430: 'Duplicate transaction at processor.',
    440: 'Processor format error.',
    441: 'Invalid transaction information.',
    460: 'Processor feature not available.',
    461: 'Unsupported card type.',
});

const EncounterTypes = new Enum({
    MESSAGING: 'Live 2-way Instant Messaging',
    ASYNCMESSAGING: 'Asynchronous Messaging',
    VIDEO: 'Live 2-way Video',
    ASYNCVIDEO: 'Asynchronous Video',
    PHONE: 'Phone Call',
    NONE: 'No Encounter',
});

const EncounterStatuses = new Enum({
    CREATED: 'Created',
    REQUESTED: 'Requested',
    SCHEDULED: 'Scheduled',
    STARTED: 'Started',
    ASSIGNED: 'Assigned a clinician',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
    DISQUALIFIED: 'Disqualified',
    DENIED: 'Denied by clinician',
    CLOSED: 'Completed and Paid For',
    EXCEPTION: 'Issue with Encounter',
    BOOKING_NEEDED: 'Patient needs to schedule Video Visit',
    BOOKING_CREATED: 'Patient scheduled Video Visit',
    BOOKING_RESCHEDULED: 'Patient re-scheduled Video Visit',
    BOOKING_CANCELLED: 'Patient cancelled Video Visit',
    BOOKING_NO_SHOW: 'Patient no-showed Video Visit',
    REPLACED: 'Replaced by New Visit',
});

const EncounterVisitTypes = new Enum({
    CONSULT: 'Consultation',
    FOLLOWUP: 'Follow-Up',
});

const PrescriptionStatuses = new Enum({
    REQUESTED: 'Requested',
    WRITTEN: 'Written by Prescriber',
    PROCESSING: 'Created at Pharmacy',
    SUBMITTED: 'Sent to Pharmacy',
    RECEIVED: 'Received by Pharmacy',
    QUEUED: 'Entered Queue for Fulfillment by Pharmacy',
    PREVERIFICATION: 'Ready for Pharmacist Pre-Verification',
    FILLING: 'Filling by Pharmacy',
    VERIFIED: 'Verified by Pharmacist',
    FILLED: 'Filled by Pharmacy',
    SHIPPED: 'Shipped',
    DELIVERED: 'Delivered',
    COMPLETED: 'Delivered and Paid For',
    VOIDED: 'Voided (Cannot be Filled)',
    ALTERNATIVE: 'Alternative Prescription',
    ALTERNATIVE_SUBMITTED: 'Alternative Prescription - Submitted',
    ALTERNATIVE_PROCESSING: 'Alternative Prescription - Processing',
    ALTERNATIVE_UNAVAILABLE: 'Alternative Prescription - Medication is Unavailable',
    CANCELLED: 'Cancelled',
    EXPIRED: 'Expired',
});

const PrescriptionGroupStatuses = new Enum({
    ACTIVE: 'Active',
    COMPLETED: 'Completed',
    EXPIRED: 'Expired',
    VOIDED: 'Voided',
});

const VoucherStatuses = new Enum({
    CREDITED: 'Added to Account',
    USED: 'Used',
    VOIDED: 'Voided or Cancelled',
    EXPIRED: 'Expired',
    REFUNDED: 'Refunded',
    COMPED: 'Complimentary Voucher Added to Account',
});

const RefundMethods = new Enum({
    CARD: 'Back to Credit/Debit Card',
    CHECK: 'Written Check',
    CASH: 'Cash',
    PRIMARY_INSURANCE: 'Primary Insurance',
    SECONDARY_INSURANCE: 'Secondary Insurance',
    TERTIARY_INSURANCE: 'Tertiary Insurance',
    CREDIT: 'Store Credit (Credit on Account)',
});

const DocumentRequirements = new Enum({
    NEW: 'New Document Each Scope',
    EXISTING: 'Use Existing Document is Available',
});

const PayoutMethods = new Enum({
    CASH: 'Cash',
    CREDIT: 'Store Credit (Credit on Account)',
});

const PayoutStatuses = new Enum({
    PENDING: 'Pending',
    PAID: 'Paid',
    RETURNED: 'Returned',
    FAILED: 'Failed',
    CANCELLED: 'Cancelled',
});

const CustomerOrderStatuses = new Enum({
    DRAFT: 'New', // Draft order created when customers start the checkout process
    CONFIRMED: 'Confirmed by Patient', // Patient Confirmed the order
    APPROVED: 'Approved by Provider', // Provider Approved the order
    DENIED: 'Denied by Provider',
    READY: 'Ready to Fill', // Order is Confirmed, Approved, and has a valid payment method attached in the payment details
    PENDING: 'Ready to Fill', // Order received, no payment initiated. Awaiting payment (unpaid). Hasn't been sent to shipment facility to be processed yet.
    PROCESSING: 'Processing at Pharmacy', // Payment received (paid) and stock has been reduced; order is awaiting fulfillment. All product orders require processing, except those that only contain products which are both virtual and downloadable
    PROCESSING_CREATED: 'Fulfilling at Pharmacy',
    PROCESSING_SUBMITTED: 'Fulfilling at Pharmacy',
    PROCESSING_RECEIVED: 'Fulfilling at Pharmacy',
    PROCESSING_QUEUED: 'Fulfilling at Pharmacy',
    PROCESSING_PREVERIFICATION: 'Fulfilling at Pharmacy',
    PROCESSING_FILLING: 'Fulfilling at Pharmacy',
    PROCESSING_VERIFIED: 'Fulfilling at Pharmacy',
    PROCESSING_FILLED: 'Fulfilling at Pharmacy',
    PROCESSING_EXCEPTION: 'Fulfilling at Pharmacy',
    SHIPMENT_CREATED: 'Shipment Label Created',
    SHIPMENT_SHIPPED: 'Shipment Has Shipped',
    SHIPMENT_DELIVERED: 'Shipment Has Been Delivered',
    SHIPMENT_CANCELLED: 'Shipment Has Been Cancelled',
    ON_HOLD: 'Fulfilling at Pharmacy',
    EXCEPTION: 'Shipment Has Shipped',
    PARTIALLY_FULFILLED: 'Partially Fulfilled', // Part of the order is completed but not all of it
    COMPLETED: 'Shipment Has Been Delivered', // Order fulfilled and complete – requires no further action. Paid has been received as well.
    CANCELLED: 'Cancelled', // Cancelled by an admin or the customer – stock is increased, no further action required. Please note: This status does not refund the customer. An example use case: The merchant wants to cancel the order because the customer has become unresponsive and they do not know where to ship the product. The customer is not eligible for a refund in this case.
    REFUNDED: 'Refunded', // Refunded by an admin – no further action required.
    AUTHENTICATION_REQUIRED: 'Authentication Required', // Awaiting action by the customer to authenticate the transaction and/or complete SCA requirements.
    FAILED: 'Failed Payment', // Payment failed or was declined (unpaid) or requires authentication (SCA). Note that this status may not show immediately and instead show as Pending until verified (e.g., PayPal).
    COLLECTIONS: 'Failed Payment', // Order is in collections due to non-payment
    SKIPPED: 'Skipped',
    DISQUALIFIED: 'Disqualified', // Customer order is disqualified because requirements for products in the order or responses to intake forms make them ineligible to receive product
    ALTERNATIVE: 'Alternative Prescription',
    ALTERNATIVE_SUBMITTED: 'Alternative Submitted to Pharmacy',
    ALTERNATIVE_PROCESSING: 'Alternative Processing at Pharmacy',
    ALTERNATIVE_UNAVAILABLE: 'Alternative Prescription Unavailable',
    MEDICATION_CHANGE: 'Medication Change',
    CLOSED: 'Shipment Has Been Delivered',
});

const WeightLossSteps = new Enum({
    INTRO_STEP: 1,
    NAME_AND_STATE_STEP: 2,
    GOALS_STEP: 3,
    GENDER_STEP: 4,
    CURRENTLY_PREGNANT_STEP: 40,
    MALE_EFFECTS_STEP: 41,
    FEMALE_EFFECTS_STEP: 42,
    ABOUT_GLP1_STEP: 43,
    PRIORITY_STEP: 44,
    BODY_SHAPE_STEP: 45,

    SOCIAL_PROOF_STEP: 34,

    HOW_GLP1_WORKS_STEP: 46,
    PRIMARY_GOAL_STEP: 47,
    GLP1_SCIENCE_STEP: 48,

    TARGET_WEIGHT_STEP: 49,
    DAY_SPENT_STEP: 50,
    ACTIVITY_LEVEL_STEP: 51,
    METABOLIC_RATE_STEP: 52,
    SLEEP_QUALITY_STEP: 53,
    SLEEP_LENGTH_STEP: 54,

    SOCIAL_PROOF_2_STEP: 35,

    STATE_STEP: 55,

    SOCIAL_PROOF_3_STEP: 36,

    MINDSET_STEP: 56,

    NAME_STEP: 57,

    BIRTHDATE_STEP: 5,
    HEIGHT_AND_WEIGHT_STEP: 6,
    CREATE_ACCOUNT_STEP: 7,
    BMI_RESULTS_STEP: 8,
    INTAKE_FORM_STEP: 9,
    MEDICATIONS_LIST_STEP: 10,
    MEDICAL_CONDITIONS_LIST_STEP: 11,
    ALLERGIES_LIST_STEP: 12,
    CURRENT_GLP1_PHOTO_CONFIRMATION_STEP: 13,
    CURRENT_GLP1_SKIP_PHOTO_STEP: 14,
    YOU_HAVE_QUALIFIED_STEP: 15,
    SHIPPING_STEP: 16,
    SIDE_EFFECTS_STEP: 70,
    DOSING_STEP: 71,
    PRODUCT_STEP: 32,
    PLAN_STEP: 33,
    CHECKOUT_STEP: 17,
    COMPOUNDED_APPROVAL_COUNTDOWN_CHECKOUT_STEP: 5000,
    COMPOUNDED_PLAN_APPROVED_CHECKOUT_STEP: 5001,
    PROGRAM_CHECKOUT_STEP: 5002,
    ORDER_CONFIRMED_STEP: 18,
    CONFIRM_STATE_STEP: 19,
    BMI_GLP1_STEP: 20,
    CONFIRM_HEIGHT_AND_WEIGHT_STEP: 21,
    STATE_DISQUALIFIED_STEP: 22,
    BIRTHDATE_DISQUALIFIED_STEP: 23,
    BMI_DISQUALIFIED_STEP: 24,
    EXISTING_MEDICATION_INTAKE_DISQUALIFIED_STEP: 25,
    FAMILY_PLANNING_INTAKE_DISQUALIFIED_STEP: 26,
    EXISTING_MEDICAL_CONDITION_INTAKE_DISQUALIFIED_STEP: 27,
    TRIGLYCERIDE_INTAKE_DISQUALIFIED_STEP: 28,
    GASTRIC_BYPASS_INTAKE_DISQUALIFIED_STEP: 29,
    SHIPPING_STATE_DISQUALIFIED_STEP: 30,
    DUPLICATE_ENROLLMENT_DISQUALIFIED: 31,
    GLP1_ALLERGY_DISQUALIFIED_STEP: 58,
    CANCER_INTAKE_DISQUALIFIED_STEP: 59
});

const WeightLossConsultSteps = new Enum({
    INTRO_STEP: 1,
    WEIGHT_LOSS_INTAKE_FORM_STEP: 2,
    MEDICATIONS_INTAKE_FORM_STEP: 3,
    MEDICAL_CONDITIONS_INTAKE_FORM_STEP: 4,
    ALLERGIES_INTAKE_FORM_STEP: 5,
    CURRENT_GLP1_CHOOSE_CONFIRMATION_STEP: 12,
    CURRENT_GLP1_PHOTO_CONFIRMATION_STEP: 6,
    CURRENT_GLP1_SKIP_PHOTO_STEP: 7,
    CURRENT_GLP1_DATA_CONFIRMATION_STEP: 13,
    DRIVERS_LICENSE_STEP: 8,
    PROGRESS_PICTURE_STEP: 9,
    REVIEW_STEP: 10,
    ENCOUNTER_CONFIRMED_STEP: 11
});

const OldLongevitySteps = new Enum({
    INTRO_STEP: 1,
    NAME_AND_STATE_STEP: 2,
    LONGEVITY_GOAL_STEP: 3,
    GENDER_STEP: 4,
    CURRENTLY_PREGNANT_STEP: 30,
    BIRTHDATE_STEP: 5,
    HEIGHT_AND_WEIGHT_STEP: 6,

    STATE_STEP: 31,
    NAME_STEP: 32,

    CREATE_ACCOUNT_STEP: 7,
    LONGEVITY_INTAKE_FORM_STEP: 8,
    MEDICATIONS_INTAKE_FORM_STEP: 9,
    MEDICAL_CONDITIONS_INTAKE_FORM_STEP: 10,
    ALLERGIES_INTAKE_FORM_STEP: 11,
    YOU_HAVE_QUALIFIED_STEP: 12,
    SHIPPING_STEP: 13,
    CHECKOUT_STEP: 14,
    ORDER_CONFIRMED_STEP: 15,
    CONFIRM_STATE_STEP: 16,
    STATE_DISQUALIFIED_STEP: 17,
    BIRTHDATE_DISQUALIFIED_STEP: 18,
    FAMILY_PLANNING_INTAKE_DISQUALIFIED_STEP: 19,
    EXISTING_MEDICAL_CONDITION_INTAKE_DISQUALIFIED_STEP: 20,
    CANCER_INTAKE_DISQUALIFIED_STEP: 21,
    SHIPPING_STATE_DISQUALIFIED_STEP: 22,
    DUPLICATE_ENROLLMENT_DISQUALIFIED: 23
});

const LongevitySteps = new Enum({
    INTRO_STEP: 1,
    GOALS_STEP: 3,
    GENDER_STEP: 4,
    CURRENTLY_PREGNANT_STEP: 40,

    INTAKE_FORM_STEP: 9,
    STATE_STEP: 55,
    NAME_STEP: 57,
    BIRTHDATE_STEP: 5,
    HEIGHT_AND_WEIGHT_STEP: 6,

    CREATE_ACCOUNT_STEP: 7,

    YOU_HAVE_QUALIFIED_STEP: 15,
    SHIPPING_STEP: 16,
    SIDE_EFFECTS_STEP: 70,
    DOSING_STEP: 71,
    PRODUCT_STEP: 32,
    PLAN_STEP: 33,
    CHECKOUT_STEP: 17,
    PROGRAM_CHECKOUT_STEP: 5002,
    ORDER_CONFIRMED_STEP: 18,

    STATE_DISQUALIFIED_STEP: 22,
    BIRTHDATE_DISQUALIFIED_STEP: 23,
    EXISTING_MEDICATION_INTAKE_DISQUALIFIED_STEP: 25,
    FAMILY_PLANNING_INTAKE_DISQUALIFIED_STEP: 26,
    EXISTING_MEDICAL_CONDITION_INTAKE_DISQUALIFIED_STEP: 27,
    CANCER_INTAKE_DISQUALIFIED_STEP: 59,
    SHIPPING_STATE_DISQUALIFIED_STEP: 30,
    DUPLICATE_ENROLLMENT_DISQUALIFIED: 31
});

const LongevityConsultSteps = new Enum({
    INTRO_STEP: 1,
    INTAKE_FORM_STEP: 2,
    MEDICATIONS_INTAKE_FORM_STEP: 3,
    MEDICAL_CONDITIONS_INTAKE_FORM_STEP: 4,
    ALLERGIES_INTAKE_FORM_STEP: 5,
    DRIVERS_LICENSE_STEP: 6,
    REVIEW_STEP: 7,
    ENCOUNTER_CONFIRMED_STEP: 8
});

const SiteEventStepNames = new Enum({
    ABANDONED_CART_LOADED: 'ABANDONED_CART_LOADED',
    ABANDONED_CART_PAID: 'ABANDONED_CART_PAID',
    ABOUT_GLP1_STEP: 'ABOUT_GLP1_STEP',
    ACTIVITY_LEVEL_STEP: 'ACTIVITY_LEVEL_STEP',
    ALLERGIES_INTAKE_FORM_STEP: 'ALLERGIES_INTAKE_FORM_STEP',
    ALLERGIES_LIST_STEP: 'ALLERGIES_LIST_STEP',
    AVOID_SIDE_EFFECTS_STEP: 'AVOID_SIDE_EFFECTS_STEP',
    BIRTHDATE_DISQUALIFIED_STEP: 'BIRTHDATE_DISQUALIFIED_STEP',
    BIRTHDATE_STEP: 'BIRTHDATE_STEP',
    BMI_DISQUALIFIED_STEP: 'BMI_DISQUALIFIED_STEP',
    BMI_GLP1_STEP: 'BMI_GLP1_STEP',
    BMI_RESULTS_STEP: 'BMI_RESULTS_STEP',
    BODY_SHAPE_STEP: 'BODY_SHAPE_STEP',
    CANCER_INTAKE_DISQUALIFIED_STEP: 'CANCER_INTAKE_DISQUALIFIED_STEP',
    COMPOUNDED_APPROVAL_COUNTDOWN_CHECKOUT_STEP: 'COMPOUNDED_APPROVAL_COUNTDOWN_CHECKOUT_STEP',
    COMPOUNDED_PLAN_APPROVED_CHECKOUT_STEP: 'COMPOUNDED_PLAN_APPROVED_CHECKOUT_STEP',
    CHECKOUT_STEP: 'CHECKOUT_STEP',
    COLLECTIONS_PAY_NOW_MODAL_FAILED: 'COLLECTIONS_PAY_NOW_MODAL_FAILED',
    COLLECTIONS_PAY_NOW_MODAL_LOADED: 'COLLECTIONS_PAY_NOW_MODAL_LOADED',
    COLLECTIONS_PAY_NOW_MODAL_PAID: 'COLLECTIONS_PAY_NOW_MODAL_PAID',
    COLLECTIONS_PAY_NOW_PAGE_FAILED: 'COLLECTIONS_PAY_NOW_PAGE_FAILED',
    COLLECTIONS_PAY_NOW_PAGE_LOADED: 'COLLECTIONS_PAY_NOW_PAGE_LOADED',
    COLLECTIONS_PAY_NOW_PAGE_PAID: 'COLLECTIONS_PAY_NOW_PAGE_PAID',
    COLLECTIONS_PROCESS_PAYMENT_FAILED: 'COLLECTIONS_PROCESS_PAYMENT_FAILED',
    COLLECTIONS_PROCESS_PAYMENT_LOADED: 'COLLECTIONS_PROCESS_PAYMENT_LOADED',
    COLLECTIONS_PROCESS_PAYMENT_PAID: 'COLLECTIONS_PROCESS_PAYMENT_PAID',
    CONFIRM_HEIGHT_AND_WEIGHT_STEP: 'CONFIRM_HEIGHT_AND_WEIGHT_STEP',
    CONFIRM_STATE_STEP: 'CONFIRM_STATE_STEP',
    CONSULT_OPENED: 'CONSULT_OPENED',
    CONSULT_RESUMED: 'CONSULT_RESUMED',
    CONSULT_SUBMITTED: 'CONSULT_SUBMITTED',
    CREATE_ACCOUNT_STEP: 'CREATE_ACCOUNT_STEP',
    CURRENT_GLP1_CHOOSE_CONFIRMATION_STEP: 'CURRENT_GLP1_CHOOSE_CONFIRMATION_STEP',
    CURRENT_GLP1_DATA_CONFIRMATION_STEP: 'CURRENT_GLP1_DATA_CONFIRMATION_STEP',
    CURRENT_GLP1_PHOTO_CONFIRMATION_STEP: 'CURRENT_GLP1_PHOTO_CONFIRMATION_STEP',
    CURRENT_GLP1_SKIP_PHOTO_STEP: 'CURRENT_GLP1_SKIP_PHOTO_STEP',
    CURRENTLY_PREGNANT_STEP: 'CURRENTLY_PREGNANT_STEP',
    DOSING_STEP: 'DOSING_STEP',
    DRIVERS_LICENSE_STEP: 'DRIVERS_LICENSE_STEP',
    DRIVERS_LICENSE_UPLOADED: 'DRIVERS_LICENSE_UPLOADED',
    DUPLICATE_ENROLLMENT_DISQUALIFIED: 'DUPLICATE_ENROLLMENT_DISQUALIFIED',
    ENCOUNTER_CONFIRMED_STEP: 'ENCOUNTER_CONFIRMED_STEP',
    EXISTING_MEDICAL_CONDITION_INTAKE_DISQUALIFIED_STEP: 'EXISTING_MEDICAL_CONDITION_INTAKE_DISQUALIFIED_STEP',
    EXISTING_MEDICATION_INTAKE_DISQUALIFIED_STEP: 'EXISTING_MEDICATION_INTAKE_DISQUALIFIED_STEP',
    FAMILY_PLANNING_INTAKE_DISQUALIFIED_STEP: 'FAMILY_PLANNING_INTAKE_DISQUALIFIED_STEP',
    FEMALE_EFFECTS_STEP: 'FEMALE_EFFECTS_STEP',
    FUNNEL_INITIATED: 'FUNNEL_INITIATED',
    GASTRIC_BYPASS_INTAKE_DISQUALIFIED_STEP: 'GASTRIC_BYPASS_INTAKE_DISQUALIFIED_STEP',
    GENDER_STEP: 'GENDER_STEP',
    GLP1_ALLERGY_DISQUALIFIED_STEP: 'GLP1_ALLERGY_DISQUALIFIED_STEP',
    GLP1_SCIENCE_STEP: 'GLP1_SCIENCE_STEP',
    GOALS_STEP: 'GOALS_STEP',
    GOVERNMENT_ID_STEP_VIEWED: 'GOVERNMENT_ID_STEP_VIEWED',
    HEIGHT_AND_WEIGHT_STEP: 'HEIGHT_AND_WEIGHT_STEP',
    HOW_GLP1_WORKS_STEP: 'HOW_GLP1_WORKS_STEP',
    IMPRESSION: 'Impression',
    INTAKE_FORM_STEP: 'INTAKE_FORM_STEP',
    INTAKE_FORM_STEP_ABOUT_GLP1_STEP: 'INTAKE_FORM_STEP - ABOUT_GLP1_STEP',
    INTAKE_FORM_STEP_ACTIVITY_LEVEL_STEP: 'INTAKE_FORM_STEP - ACTIVITY_LEVEL_STEP',
    INTAKE_FORM_STEP_BODY_SHAPE_STEP: 'INTAKE_FORM_STEP - BODY_SHAPE_STEP',
    INTAKE_FORM_STEP_CURRENT_OR_PAST_HEALTH_ISSUES_STEP: 'INTAKE_FORM_STEP - CURRENT_OR_PAST_HEALTH_ISSUES_STEP',
    INTAKE_FORM_STEP_CURRENT_OR_PAST_MEDICAL_CONDITIONS_STEP: 'INTAKE_FORM_STEP - CURRENT_OR_PAST_MEDICAL_CONDITIONS_STEP',
    INTAKE_FORM_STEP_CURRENTLY_PREGNANT_STEP: 'INTAKE_FORM_STEP - CURRENTLY_PREGNANT_STEP',
    INTAKE_FORM_STEP_DAY_SPENT_STEP: 'INTAKE_FORM_STEP - DAY_SPENT_STEP',
    INTAKE_FORM_STEP_DISQUALIFYING_MEDICATIONS_STEP: 'INTAKE_FORM_STEP - DISQUALIFYING_MEDICATIONS_STEP',
    INTAKE_FORM_STEP_FEMALE_EFFECTS_STEP: 'INTAKE_FORM_STEP - FEMALE_EFFECTS_STEP',
    INTAKE_FORM_STEP_GASTRIC_BYPASS_STEP: 'INTAKE_FORM_STEP - GASTRIC_BYPASS_STEP',
    INTAKE_FORM_STEP_GLP1_SCIENCE_STEP: 'INTAKE_FORM_STEP - GLP1_SCIENCE_STEP',
    INTAKE_FORM_STEP_HEAR_FROM_DOCTOR_STEP: 'INTAKE_FORM_STEP - HEAR_FROM_DOCTOR_STEP',
    INTAKE_FORM_STEP_HOW_GLP1_WORKS_STEP: 'INTAKE_FORM_STEP - HOW_GLP1_WORKS_STEP',
    INTAKE_FORM_STEP_MALE_EFFECTS_STEP: 'INTAKE_FORM_STEP - MALE_EFFECTS_STEP',
    INTAKE_FORM_STEP_METABOLIC_RATE_STEP: 'INTAKE_FORM_STEP - METABOLIC_RATE_STEP',
    INTAKE_FORM_STEP_MINDSET_STEP: 'INTAKE_FORM_STEP - MINDSET_STEP',
    INTAKE_FORM_STEP_PRIMARY_GOAL_STEP: 'INTAKE_FORM_STEP - PRIMARY_GOAL_STEP',
    INTAKE_FORM_STEP_PRIORITY_STEP: 'INTAKE_FORM_STEP - PRIORITY_STEP',
    INTAKE_FORM_STEP_SLEEP_LENGTH_STEP: 'INTAKE_FORM_STEP - SLEEP_LENGTH_STEP',
    INTAKE_FORM_STEP_SLEEP_QUALITY_STEP: 'INTAKE_FORM_STEP - SLEEP_QUALITY_STEP',
    INTAKE_FORM_STEP_SOCIAL_PROOF_2_STEP_FEMALE: 'INTAKE_FORM_STEP - SOCIAL_PROOF_2_STEP - FEMALE',
    INTAKE_FORM_STEP_SOCIAL_PROOF_2_STEP_MALE: 'INTAKE_FORM_STEP - SOCIAL_PROOF_2_STEP - MALE',
    INTAKE_FORM_STEP_SOCIAL_PROOF_STEP_FEMALE: 'INTAKE_FORM_STEP - SOCIAL_PROOF_STEP - FEMALE',
    INTAKE_FORM_STEP_SOCIAL_PROOF_STEP_MALE: 'INTAKE_FORM_STEP - SOCIAL_PROOF_STEP - MALE',
    INTRO_STEP: 'INTRO_STEP',
    LONGEVITY_GOAL_STEP: 'LONGEVITY_GOAL_STEP',
    LONGEVITY_INTAKE_FORM_STEP: 'LONGEVITY_INTAKE_FORM_STEP',
    MALE_EFFECTS_STEP: 'MALE_EFFECTS_STEP',
    MEDICAL_CONDITIONS_INTAKE_FORM_STEP: 'MEDICAL_CONDITIONS_INTAKE_FORM_STEP',
    MEDICAL_CONDITIONS_LIST_STEP: 'MEDICAL_CONDITIONS_LIST_STEP',
    MEDICATIONS_INTAKE_FORM_STEP: 'MEDICATIONS_INTAKE_FORM_STEP',
    MEDICATIONS_LIST_STEP: 'MEDICATIONS_LIST_STEP',
    METABOLIC_RATE_STEP: 'METABOLIC_RATE_STEP',
    MINDSET_STEP: 'MINDSET_STEP',
    NAME_AND_STATE_STEP: 'NAME_AND_STATE_STEP',
    NAME_STEP: 'NAME_STEP',
    NEW_ACCOUNT_CREATED: 'NEW_ACCOUNT_CREATED',
    ORDER_CONFIRMED_STEP: 'ORDER_CONFIRMED_STEP',
    PAGE_VIEW: 'Page View',
    PAY_NOW_LINK_FAILED: 'PAY_NOW_LINK_FAILED',
    PAY_NOW_LINK_LOADED: 'PAY_NOW_LINK_LOADED',
    PAY_NOW_LINK_PAID: 'PAY_NOW_LINK_PAID',
    PAY_NOW_MODAL_FAILED: 'PAY_NOW_MODAL_FAILED',
    PAY_NOW_MODAL_LOADED: 'PAY_NOW_MODAL_LOADED',
    PAY_NOW_MODAL_PAID: 'PAY_NOW_MODAL_PAID',
    PAYMENT_AUTH: 'PAYMENT_AUTH',
    PHONE_VERIFICATION_MODAL_SHOWN: 'PHONE_VERIFICATION_MODAL_SHOWN',
    PHONE_VERIFIED: 'PHONE_VERIFIED',
    PLACEHOLDER_MALE_PREGNANCY: 'PLACEHOLDER_MALE_PREGNANCY',
    PLAN_STEP: 'PLAN_STEP',
    PRIMARY_GOAL_STEP: 'PRIMARY_GOAL_STEP',
    PRIORITY_STEP: 'PRIORITY_STEP',
    PRODUCT_STEP: 'PRODUCT_STEP',
    PROGRAM_CHECKOUT_STEP: 'PROGRAM_CHECKOUT_STEP',
    PROGRESS_PICTURE_STEP: 'PROGRESS_PICTURE_STEP',
    RESEND_PHONE_VERIFICATION_CODE: 'RESEND_PHONE_VERIFICATION_CODE',
    REVIEW_STEP: 'REVIEW_STEP',
    SEND_LINK_TO_PHONE: 'SEND_LINK_TO_PHONE',
    SEND_PHONE_VERIFICATION_CODE: 'SEND_PHONE_VERIFICATION_CODE',
    SHIPPING_STATE_DISQUALIFIED_STEP: 'SHIPPING_STATE_DISQUALIFIED_STEP',
    SHIPPING_STEP: 'SHIPPING_STEP',
    SIDE_EFFECTS_STEP: 'SIDE_EFFECTS_STEP',
    SLEEP_LENGTH_STEP: 'SLEEP_LENGTH_STEP',
    SLEEP_QUALITY_STEP: 'SLEEP_QUALITY_STEP',
    SOCIAL_PROOF_2_STEP: 'SOCIAL_PROOF_2_STEP',
    SOCIAL_PROOF_3_STEP: 'SOCIAL_PROOF_3_STEP',
    SOCIAL_PROOF_STEP: 'SOCIAL_PROOF_STEP',
    STATE_DISQUALIFIED_STEP: 'STATE_DISQUALIFIED_STEP',
    STATE_STEP: 'STATE_STEP',
    SUBSCRIPTION_REACTIVATION_FAILED: 'SUBSCRIPTION_REACTIVATION_FAILED',
    SUBSCRIPTION_REACTIVATION_LOADED: 'SUBSCRIPTION_REACTIVATION_LOADED',
    SUBSCRIPTION_REACTIVATION_PAID: 'SUBSCRIPTION_REACTIVATION_PAID',
    RETENTION_SUBSCRIPTION_REACTIVATION_FAILED: 'RETENTION_SUBSCRIPTION_REACTIVATION_FAILED',
    RETENTION_SUBSCRIPTION_REACTIVATION_LOADED: 'RETENTION_SUBSCRIPTION_REACTIVATION_LOADED',
    RETENTION_SUBSCRIPTION_REACTIVATION_PAID: 'RETENTION_SUBSCRIPTION_REACTIVATION_PAID',
    TARGET_WEIGHT_STEP: 'TARGET_WEIGHT_STEP',
    TRIGLYCERIDE_INTAKE_DISQUALIFIED_STEP: 'TRIGLYCERIDE_INTAKE_DISQUALIFIED_STEP',
    TRUTHFULNESS_CONSENT_ACCEPTED: 'TRUTHFULNESS_CONSENT_ACCEPTED',
    TRUTHFULNESS_CONSENT_VIEWED: 'TRUTHFULNESS_CONSENT_VIEWED',
    WEIGHT_LOSS_INTAKE_FORM_STEP: 'WEIGHT_LOSS_INTAKE_FORM_STEP',
    YOU_HAVE_QUALIFIED_STEP: 'YOU_HAVE_QUALIFIED_STEP',
    C_SE_GET_STARTED_PRODUCT: 'c-se_get-started_product',
    C_TI_GET_STARTED_PRODUCT: 'c-ti_get-started_product',
    GL_GET_STARTED_PRODUCT: 'gl_get-started_product',
    GL_GET_STARTED_RESULTS: 'gl_get-started_results',
    GL_GET_STARTED_TIMELINE_STEPS: 'gl_get-started_timeline-steps',
    GL_GET_STARTED_TOP: 'gl_get-started_top',
    GL_TOPBAR_GET_STARTED_WL: 'gl-topbar_get-started_wl',
    GLP1_LANDING_GET_STARTED_CTA: 'glp1-landing_get-started_cta',
    GLP1_LANDING_GET_STARTED_FLOATING: 'glp1-landing_get-started_floating',
    GLP1_LANDING_GET_STARTED_HERO: 'glp1-landing_get-started_hero',
    GLP1_LANDING_GET_STARTED_HOW_IT_WORKS: 'glp1-landing_get-started_how-it-works',
    HOME_GET_STARTED_SE: 'home_get-started_se',
    ME_GET_STARTED_PRODUCT: 'me_get-started_product',
    ME_GET_STARTED_RESULTS: 'me_get-started_results',
    ME_GET_STARTED_TIMELINE_STEPS: 'me_get-started_timeline-steps',
    ME_GET_STARTED_TOP: 'me_get-started_top',
    ME_TOPBAR_GET_STARTED_WL: 'me-topbar_get-started_wl',
    NA_GET_STARTED_PRODUCT: 'na_get-started_product',
    NA_GET_STARTED_RESULTS: 'na_get-started_results',
    NA_GET_STARTED_TIMELINE_STEPS: 'na_get-started_timeline-steps',
    NA_GET_STARTED_TOP: 'na_get-started_top',
    NA_TOPBAR_GET_STARTED_WL: 'na-topbar_get-started_wl',
    OZ_GET_STARTED_PRODUCT: 'oz_get-started_product',
    SE_GET_STARTED_RESULTS: 'se_get-started_results',
    SE_GET_STARTED_RESULTS_MOBILE: 'se_get-started_results-mobile',
    SE_GET_STARTED_TIMELINE_STEPS: 'se_get-started_timeline-steps',
    SE_GET_STARTED_TOP: 'se_get-started_top',
    SE_TOPBAR_GET_STARTED_WL: 'se-topbar_get-started_wl',
    TI_GET_STARTED_RESULTS: 'ti_get-started_results',
    TI_GET_STARTED_RESULTS_MOBILE: 'ti_get-started_results-mobile',
    TI_GET_STARTED_TIMELINE_STEPS: 'ti_get-started_timeline-steps',
    TI_GET_STARTED_TOP: 'ti_get-started_top',
    TI_TOPBAR_GET_STARTED_WL: 'ti-topbar_get-started_wl',
    ZE_GET_STARTED_PRODUCT: 'ze_get-started_product'
});

const CheckInTypes = new Enum({
    VIDEO: 'Live 2-way Video',
    ASYNCVIDEO: 'Asynchronous Video',
    PHONE: 'Phone Call',
    SELF: 'Self Check-In',
    EVENT: 'Event'
});

const CheckInStatuses = new Enum({
    CREATED: 'Created',
    REQUESTED: 'Requested',
    SCHEDULED: 'Scheduled',
    STARTED: 'Started',
    ASSIGNED: 'Assigned a facilitator',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
});

const MealPlanStatuses = new Enum({
    REQUESTED: 'Requested',
    GENERATED: 'Generated',
    ERROR: 'Error',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
    ACTIVE: 'Active',
    ARCHIVED: 'Archived',
});

const MealTypes = new Enum({
    BREAKFAST: 'Breakfast',
    LUNCH: 'Lunch',
    DINNER: 'Dinner',
    SNACK: 'Snack',
});

const MealDays = new Enum({
    MONDAY: 'Monday',
    TUESDAY: 'Tuesday',
    WEDNESDAY: 'Wednesday',
    THURSDAY: 'Thursday',
    FRIDAY: 'Friday',
    SATURDAY: 'Saturday',
    SUNDAY: 'Sunday',
});

const MealPlanReviewStatuses = new Enum({
    PENDING: 'Pending',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
});

const VendorPaymentMethods = new Enum({
    CARD: 'Credit/Debit Card',
    ECHECK: 'E-Check',
    CHECK: 'Check',
    ACH: 'Electronic Bank Transfer via ACH',
    WIRE: 'Wire Transfer',
    CASH: 'Cash',
    OTHER: 'Other',
});

const TitrationSchedules = new Enum({
    NONE: 'No Titration',
    STANDARD: 'Standard/Branded Dosing Titration',
    ALTERNATIVE: 'Alternative Dosing Titration',
    SPLIT: 'Split Dosing Titration',
    RAPID: 'Rapid Dosing Titration',
});

const EventTypes = new Enum({
    SESSION: 'Session',
    WEBINAR: 'Webinar',
    CONFERENCE: 'Conference',
    WORKSHOP: 'Workshop',
    OTHER: 'Other',
});

const EventStatuses = new Enum({
    DRAFT: 'Draft',
    PUBLISHED: 'Published - Visible to Patients',
    PRIVATE: 'Private - Visible to Staff Only',
});

const EventPlatforms = new Enum({
    ZOOM: 'Zoom',
    GOOGLE_MEET: 'Google Meet',
    MICROSOFT_TEAMS: 'Microsoft Teams',
    OTHER: 'Other',
});

const CommunityTypes = new Enum({
    COMMUNITY: 'Community',
    GROUP: 'Group',
});

const CommunityPrivacies = new Enum({
    PUBLIC: 'Public',
    PRIVATE: 'Private',
    HIDDEN: 'Hidden',
});

const TaskCategories = new Enum({
    NONE: 'None',
    GENERAL: 'General',
    WELCOME: 'Welcome Call',
    INTAKE: 'Intake/Sign-Up',
    ENCOUNTER: 'Encounter',
    PATIENT: 'Patient',
    ORDER: 'Order',
    PRESCRIPTION: 'Prescription',
    SUBSCRIPTION: 'Subscription',
    REFUND: 'Refund',
    VOUCHER: 'Voucher',
    RENEWAL: 'Renewal',
    PAUSE: 'Pause',
    REACTIVATE: 'Reactivate',
    CANCELLATION: 'Cancellation',
    CHARGE_BACK: 'Charge Back',
    SCHEDULING: 'Scheduling',
    FOLLOW_UP: 'Follow-up',
    OUTREACH: 'Outreach',
    PAPERWORK: 'Paperwork',
    BILLING: 'Billing',
    INSURANCE: 'Insurance',
    CLINICAL: 'Clinical',
    PHARMACY: 'Pharmacy',
    TEST: 'Test',
    VACCINATION: 'Vaccination',
    ABANDONED_CART: 'Abandoned Cart',
    RE_ENGAGEMENT: 'Re-engagement',
    SURVEY: 'Survey',
    APPOINTMENT_REMINDER: 'Appointment Reminder',
    REFILL_REMINDER: 'Refill Reminder',
    RETENTION: 'Retention',
    ONBOARDING: 'Onboarding',
    PRESCRIPTION_CLARIFICATION: 'Prescription Clarification',
    COLLECTIONS: 'Collections',
    MISSED_CALL: 'Missed Call',
    VOICEMAIL: 'Voicemail',
    CUSTOMER_SERVICE: 'Customer Service',
    SALES: 'Sales',
    SUPPORT_GENERAL: 'General Support',
    SUPPORT_ACCOUNT: 'Account Issue',
    SUPPORT_TECHNICAL: 'Technical Issue',
    SUPPORT_SHIPPING: 'Shipping Issue',
    SUPPORT_PRODUCT: 'Product Question',
    SUPPORT_RETURNS: 'Returns & Exchanges',
    OTHER: 'Other'
});

const TaskTypes = new Enum({
    TASK: 'Task',
    TICKET: 'Ticket'
});

const TicketChannels = new Enum({
    CHAT: 'Chat',
    EMAIL: 'Email',
    SMS: 'SMS',
    PHONE: 'Phone',
    INTERNAL: 'Internal',
    SYSTEM: 'System'
});

const EscalationLevels = new Enum({
    NORMAL: 'Normal',
    ESCALATED: 'Escalated',
    CRITICAL: 'Critical'
});

const TicketEventTypes = new Enum({
    CREATED: 'Created',
    CUSTOMER_REPLIED: 'Customer Replied',
    STAFF_REPLIED: 'Staff Replied',
    CUSTOMER_COMMENT: 'Customer Comment',
    STAFF_COMMENT: 'Staff Comment',
    STATUS_CHANGED: 'Status Changed',
    ASSIGNED: 'Assignment Changed',
    PRIORITY_CHANGED: 'Priority Changed',
    CATEGORY_CHANGED: 'Category Changed',
    ESCALATED: 'Escalated',
    RESOLVED: 'Resolved',
    REOPENED: 'Reopened',
    TEMPLATE_APPLIED: 'Template Applied',
    HANDOFF_CREATED: 'Handoff Created',
    FOLLOWERS_UPDATED: 'Followers Updated'
});

const SupportReplyTemplateChannels = new Enum({
    ALL: 'All Channels',
    EMAIL: 'Email',
    SMS: 'SMS',
    CHAT: 'Chat',
    PHONE: 'Phone'
});

const SupportHandoffTypes = new Enum({
    VENDOR: 'Vendor',
    PHARMACY: 'Pharmacy',
    COVERED_ENTITY: 'Covered Entity',
    BILLING: 'Billing',
    REFUND: 'Refund',
    OTHER: 'Other'
});

const SupportRoutingStatuses = new Enum({
    AVAILABLE: 'Available',
    AWAY: 'Away',
    OFFLINE: 'Offline'
});

const SupportPresenceModes = new Enum({
    VIEWING: 'Viewing',
    REPLYING: 'Replying'
});

const SupportViewScopes = new Enum({
    PERSONAL: 'Personal',
    SHARED: 'Shared'
});

const TaskStatuses = new Enum({
    PENDING: 'Pending',
    IN_PROGRESS: 'In Progress',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
});

const TaskPriorities = new Enum({
    LOW: 'Low',
    MEDIUM: 'Medium',
    HIGH: 'High',
    URGENT: 'Urgent'
});

const WalletTransactionType = new Enum({
    EARNED: "EARNED",
    REDEEMED: "REDEEMED",
    EXPIRED: "EXPIRED",
    VOIDED: "VOIDED",
    REFUNDED: "REFUNDED",
    CREDITED: "CREDITED",
    CUSTOMER_SERVICE_CREDITED: "CUSTOMER_SERVICE_CREDITED",
    EXCHANGED: "EXCHANGED",
    PURCHASED: "PURCHASED"
});

const CurrencyType = new Enum({
    RX: "RX",
    COIN: "COIN",
    POINT: "POINT",
    XP: "XP",
    KARMA: "KARMA",
});

const Frequency = new Enum({
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
});

const HabitCategories = new Enum({
    HEALTH: 'Health',
    FITNESS: 'Fitness',
    NUTRITION: 'Nutrition',
    MENTAL_HEALTH: 'Mental Health',
    OTHER: 'Other'
});

const CancellationReasons = new Enum({
    NOT_WORKING: 'Not Working',
    SIDE_EFFECTS: 'Side Effects',
    TOO_EXPENSIVE: 'Too Expensive',
    FOUND_ALTERNATIVE: 'Found Alternative',
    DOCTOR_ADVISED: 'Doctor Advised',
    PERSONAL_REASONS: 'Personal Reasons',
    DELIVERY_ISSUES: 'Delivery Issues',
    CUSTOMER_SERVICE: 'Customer Service',
    OTHER: 'Other'
});

const PauseReasons = new Enum({
    FINANCIAL: 'Financial',
    SIDE_EFFECTS: 'Side Effects',
    TRAVEL: 'Travel',
    MEDICAL_REASONS: 'Medical Reasons',
    LIFESTYLE_CHANGE: 'Lifestyle Change',
    INSURANCE_CHANGE: 'Insurance Change',
    PREGNANCY: 'Pregnancy',
    OTHER: 'Other'
});

const SatisfactionRatings = new Enum({
    VERY_SATISFIED: '5 - Very Satisfied',
    SATISFIED: '4 - Satisfied',
    NEUTRAL: '3 - Neutral',
    DISSATISFIED: '2 - Dissatisfied',
    VERY_DISSATISFIED: '1 - Very Dissatisfied'
});

const RecommendationOptions = new Enum({
    YES: 'Yes',
    MAYBE: 'Maybe',
    NO: 'No'
});

const Priorities = new Enum({
    LOW: 'Low',
    NORMAL: 'Normal',
    HIGH: 'High',
    URGENT: 'Urgent'
});

const CancellationRequestStatuses = new Enum({
    PENDING: 'Pending',
    IN_PROGRESS: 'In Progress',
    CANCELLED: 'Cancelled',
    RETAINED: 'Retained'
});

const CancellationRequestRetentionOfferTypes = new Enum({
    DISCOUNT: 'Discount Offered',
    FREE_MONTH: 'Free Month Offered',
    PRODUCT_SWITCH: 'Product Switch Offered',
    FREQUENCY_SWITCH: 'Frequency Switch Offered',
    PAUSE_OPTION: 'Pause Option Offered',
    DOSAGE_ADJUSTMENT: 'Dosage Adjustment Offered',
    CONSULTATION: 'Medical Consultation Offered',
    OTHER: 'Other Offer'
});

const CancellationRequestResolutionTypes = new Enum({
    CANCELLED: 'Cancelled',
    RETAINED: 'Retained',
    PAUSED: 'Paused',
    PRODUCT_CHANGED: 'Product Changed',
    FREQUENCY_CHANGED: 'Frequency Changed',
    REFUNDED: 'Refunded',
    OTHER: 'Other'
});

const Carriers = new Enum({
    FEDEX: 'FedEx',
    UPS: 'UPS',
    USPS: 'USPS',
});

const CarrierShippingMethods = new Enum({
    usps_first_class_mail_flat: 'usps_first_class_mail_flat',
    usps_first: 'usps_first',
    usps_ground_advantage: 'usps_ground_advantage',
    ups_second_day_air: 'ups_second_day_air',
    ups_second_day_air_asr: 'ups_second_day_air_asr',
    ups_next_day_air: 'ups_next_day_air',
    ups_next_day_air_saver: 'ups_next_day_air_saver',
    ups_next_day_air_saver_asr: 'ups_next_day_air_saver_asr',
});

const MedicationAdministrationRoutes = new Enum({
    SUBCUTANEOUS: 'Subcutaneous',
    INTRAMUSCULAR: 'Intramuscular',
    ORAL: 'Oral',
    TOPICAL: 'Topical',
    NASAL: 'Nasal',
    SUBLINGUAL: 'Sublingual',
    TRANSDERMAL: 'Transdermal',
    INHALATION: 'Inhalation',
    OTHER: 'Other'
});

const MedicationInjectionSites = new Enum({
    LEFT_ABDOMEN: 'Left Abdomen',
    RIGHT_ABDOMEN: 'Right Abdomen',
    LEFT_THIGH: 'Left Thigh',
    RIGHT_THIGH: 'Right Thigh',
    LEFT_ARM: 'Left Arm',
    RIGHT_ARM: 'Right Arm',
    LEFT_BUTTOCK: 'Left Buttock',
    RIGHT_BUTTOCK: 'Right Buttock',
    OTHER: 'Other'
});

const HydrationStatuses = new Enum({
    WELL_HYDRATED: 'Well Hydrated',
    ADEQUATE: 'Adequate',
    NEEDS_IMPROVEMENT: 'Needs Improvement',
    DEHYDRATED: 'Dehydrated'
});

const WellnessResponseScores = new Enum({
    1: '1 - Very Low',
    2: '2 - Low',
    3: '3 - Neutral',
    4: '4 - Good',
    5: '5 - Excellent'
});

const MealPlanGoals = new Enum({
    WEIGHT_LOSS: 'Weight Loss',
    MAINTAIN: 'Maintain Weight and Muscle',
    GAIN_MUSCLE: 'Gain Muscle',
});

const PaymentGateways = new Enum({
    NMI: 'NMI',
    REVOLV3: 'REVOLV3',
    KLARNA: 'KLARNA',
});

// Biomarker value types
const BiomarkerValueTypes = new Enum({
    NUMERIC: 'Numeric',
    RANGE: 'Range',
    COMMENT: 'Comment/Text',
    BOOLEAN: 'Boolean',
});

// Biomarker base testing frequency
const BiomarkerFrequencies = new Enum({
    BASELINE: 'Baseline (One-Time)',
    ANNUAL: 'Annual (1x/yr)',
    SEMI_ANNUAL: 'Semi-Annual (2x/yr)',
    QUARTERLY: 'Quarterly (4x/yr)',
    POST_RX: 'Post-Rx (30-45 Days)',
    POST_DOSE_CHANGE: 'Post-Dose Change',
    AS_NEEDED: 'As Needed',
    PER_VISIT: 'Per Visit',
});

// Sex applicability for biomarkers
const SexApplicability = new Enum({
    ALL: 'All Patients',
    MALE: 'Male Only',
    FEMALE: 'Female Only',
});

// Lab panel types
const PanelTypes = new Enum({
    BASELINE: 'Baseline Panel',
    SEMI_ANNUAL: 'Semi-Annual Panel',
    ANNUAL: 'Annual Panel',
    TREATMENT_QUARTERLY: 'Treatment Quarterly Panel',
    POST_RX: 'Post-Rx Panel',
    POST_DOSE_CHANGE: 'Post-Dose Change Panel',
    ADD_ON: 'Add-On Package',
    SPECIALTY: 'Specialty Lab Panel',
});

// Test schedule entry types
const TestScheduleTypes = new Enum({
    BASELINE: 'Baseline',
    QUARTERLY: 'Quarterly',
    SEMI_ANNUAL: 'Semi-Annual',
    ANNUAL: 'Annual',
    POST_RX: 'Post-Rx',
    POST_DOSE_CHANGE: 'Post-Dose Change',
    AS_NEEDED: 'As Needed',
});

// Collection methods for lab specimens
const CollectionMethods = new Enum({
    WALK_IN: 'Walk-in Lab Visit',
    AT_HOME_TEST_KIT: 'At-Home Test Kit',
    AT_HOME_PHLEBOTOMY: 'At-Home Phlebotomy',
});

// Lab interpretation of results
const LabInterpretations = new Enum({
    NORMAL: 'Normal',
    ABNORMAL: 'Abnormal',
    CRITICAL: 'Critical',
    INCONCLUSIVE: 'Inconclusive',
});

// Optimal/functional range interpretation
const OptimalInterpretations = new Enum({
    CRITICAL_LOW: 'Critically Low',
    LOW: 'Low',
    BORDERLINE_LOW: 'Borderline Low',
    OPTIMAL: 'Optimal',
    BORDERLINE_HIGH: 'Borderline High',
    HIGH: 'High',
    CRITICAL_HIGH: 'Critically High',
});

// Health score labels
const HealthScoreLabels = new Enum({
    CRITICAL: 'Critical',
    NEEDS_ATTENTION: 'Needs Attention',
    GOOD: 'Good',
    VERY_GOOD: 'Very Good',
    OPTIMAL: 'Optimal',
});

// AI insight types
const InsightTypes = new Enum({
    RESULT_SUMMARY: 'Result Summary',
    ACTION_PLAN: 'Action Plan',
    RECOMMENDATION: 'Recommendation',
    ALERT: 'Alert',
    TREND_ANALYSIS: 'Trend Analysis',
});

// Insight priority levels
const InsightPriorities = new Enum({
    LOW: 'Low',
    MEDIUM: 'Medium',
    HIGH: 'High',
    URGENT: 'Urgent',
});

// Insight action types
const InsightActionTypes = new Enum({
    LIFESTYLE: 'Lifestyle Change',
    SUPPLEMENT: 'Supplement',
    FOLLOW_UP_TEST: 'Follow-up Test',
    CONSULT_PHYSICIAN: 'Consult Physician',
    DIETARY: 'Dietary Change',
    EXERCISE: 'Exercise',
});

// Health categories for biomarker grouping
const HealthCategories = new Enum({
    METABOLIC: 'Metabolic Health',
    HEART_LIPIDS: 'Heart & Lipids',
    FATTY_ACIDS: 'Fatty Acids',
    LIVER: 'Liver Function',
    KIDNEY: 'Kidney Function',
    THYROID: 'Thyroid',
    HORMONE_MALE: 'Male Hormones',
    HORMONE_FEMALE: 'Female Hormones',
    STRESS_AGING: 'Stress & Aging',
    NUTRIENTS: 'Vitamins & Minerals',
    HEAVY_METALS: 'Heavy Metals',
    PANCREAS: 'Pancreas',
    AUTOIMMUNITY: 'Autoimmunity',
    ELECTROLYTES: 'Electrolytes',
    CBC_BLOOD: 'CBC / Blood',
    MUSCLE: 'Muscle',
    BONE_HEALTH: 'Bone Health',
    COAGULATION: 'Coagulation',
    URINALYSIS: 'Urinalysis',
    BIO_AGE: 'Biological Age',
    GENETICS: 'Genetics',
});

// Biomarker classification within a panel (safety vs efficacy)
const BiomarkerClassifications = new Enum({
    SAFETY: 'Safety',
    EFFICACY: 'Efficacy',
});

// User test trigger types
const UserTestTriggerTypes = new Enum({
    SCHEDULED: 'Scheduled',
    POST_RX: 'Post-Rx',
    POST_DOSE_CHANGE: 'Post-Dose Change',
    AS_NEEDED: 'As Needed',
    PROVIDER_ORDERED: 'Provider Ordered',
});

const EmailTemplateTypes = new Enum({
    LEAD: 'Lead',
    USER: 'Patient',
    ORDER: 'Order',
    ORDER_GROUP: 'Order Group',
    SUBSCRIPTION: 'Subscription',
    ENCOUNTER: 'Encounter',
    CHECK_IN: 'Check-In',
});

// A funnel experiment's unit of variation. STEP_VARIANT_GROUP swaps which member of a variant group
// of sibling steps is walked; FUNNEL_VERSION swaps which ?v= survey version is served
const FunnelExperimentScopes = new Enum({
    STEP_VARIANT_GROUP: 'Step Variant Group',
    FUNNEL_VERSION: 'Funnel Version',
});

const FunnelExperimentStatuses = new Enum({
    DRAFT: 'Draft',
    RUNNING: 'Running',
    PAUSED: 'Paused',
    COMPLETED: 'Completed',
    ARCHIVED: 'Archived',
});

const NewDashboardTutorialStatuses = new Enum({
    UNSEEN: 'Unseen',
    COMPLETED: 'Completed',
    SKIPPED_DECLINED: 'Skipped - Declined',
    SKIPPED_DEFERRED: 'Skipped - View Later',
});

const OtpChannels = new Enum({
    EMAIL: 'Email',
    SMS: 'Text Message',
});

// the event queue (docs/EVENT_QUEUE.md): each key names a queue at queues/{QUEUE_KEY}/jobs
const QueueKeys = new Enum({
    AGREEMENT_GENERATION: 'Agreement Generation',
});

const QueueJobStatuses = new Enum({
    PENDING: 'Pending',
    RUNNING: 'Running',
    COMPLETED: 'Completed',
    FAILED: 'Failed', // waiting for its next round
    HELD: 'Held', // out of automatic rounds; runs again only by hand
});

const QueueJobRunStatuses = new Enum({
    PENDING: 'Pending',
    RUNNING: 'Running',
    SUCCEEDED: 'Succeeded',
    FAILED: 'Failed',
    ABANDONED: 'Abandoned', // died mid-run or never started; counted as a failed attempt
    SKIPPED: 'Skipped', // another run was already working on the job
});

const QueueRunTriggers = new Enum({
    INITIAL: 'Initial',
    RETRY: 'Hourly Retry',
    MANUAL: 'Manual',
});

const AgreementGenerationOutcomes = new Enum({
    GENERATED: 'Generated',
    ALREADY_SIGNED: 'Already Signed',
    NOT_PUBLISHED: 'Not Published',
    FAILED: 'Failed',
});

const AgreementIpAddressSources = new Enum({
    BROWSER: 'Browser',
    REQUEST: 'Request',
    LEAD: 'Lead',
});

const CaptureReviewReasons = new Enum({
    CAPTURE_APPROVED: 'Capture Approved But Order Unpaid', // money was taken by a capture the order never recorded
    CAPTURE_MAY_HAVE_SUCCEEDED: 'Capture May Have Succeeded', // a capture got no clear answer and the auth can no longer be voided
    AUTH_NOT_VOIDED: 'Auth Could Not Be Voided', // a capture got no clear answer and the void meant to settle it did not go through
});

const Enums = {
    PendingMessageStatuses,
    ShipmentStatuses,
    YesNo,
    DayOfWeek,
    CallStatuses,
    ResumeLinkRevokedReasons,
    ResumeLinkTypes,
    ResumeLinkMintSources,
    SignInMethods,
    TimeUnits,
    ContactMethods,
    CallWindowPreferences,
    DistanceUnits,
    WeightUnits,
    LengthUnits,
    VolumeUnits,
    TemperatureUnits,
    UnitOfMeasure,
    Currencies,
    Counts,
    TimeZones,
    USATimeZones,
    Genders,
    Races,
    Ethnicities,
    PrimaryMemberRelationships,
    InsuranceRanks,
    OrderStatuses,
    SubscriptionStatuses,
    Suffixes,
    InsuranceStatuses,
    LeadStatuses,
    PlanTypes,
    BillingStatuses,
    OrderTypes,
    SubscriptionBillingPeriods,
    LeadEmailTemplates,
    OrderEmailTemplates,
    EntityTypes,
    CoveredEntityTypes,
    PolicyTypes,
    PatientRelationshipToSubscribers,
    SelfIdentifiedGenders,
    AgeCategories,
    SelfIdentifiedRaces,
    SelfIdentifiedEthnicities,
    CovidTestingReasons,
    CovidSymptoms,
    CovidVaccinationStatuses,
    YesNoNoAnswer,
    MessageStatuses,
    MessageDirections,
    ActivityTypes,
    ActivityDirections,
    CoveredEntityRoles,
    DocumentTypes,
    PatientDocumentTypes,
    DocumentReviewStatuses,
    ProductStatuses,
    StockStatuses,
    TaxStatuses,
    SubscriptionLimits,
    ProductTypes,
    ShippingCalculationTypes,
    PaymentMethods,
    PaymentStatuses,
    DiscountTypes,
    DiscountTargets,
    CouponDiscountTargetTypes,
    CouponDiscountVariantScopes,
    CommercialEquivalencyVariantMatchStrategies,
    FunnelChoiceSetRenderModes,
    FunnelChoiceProductResolutionModes,
    FunnelChoiceDefaultVariantStrategies,
    MedicationTransitionSurveyReuseModes,
    MedicationTransitionDoseStrategies,
    MedicationTransitionFutureBundleCountModes,
    MedicationTransitionScopeTypes,
    MedicationTransitionLogStatuses,
    MedicationTransitionTypes,
    DuplicateCheckScopes,
    DuplicateCheckModes,
    DuplicateBlockingStatuses,
    SurveyFlowKeys,
    SurveyScopes,
    VaccinationStatuses,
    VaccinationRequirements,
    VaccinationTypes,
    TestStatuses,
    UserTestUserResults,
    UserTestClinicianResults,
    UserTestResultStatuses,
    UserTestStatuses,
    TestSpecimens,
    TransactionTypes,
    TransactionStatuses,
    AVSResponseCodes,
    CVVResponseCodes,
    TransactionResultCodes,
    EncounterTypes,
    EncounterStatuses,
    EncounterVisitTypes,
    PrescriptionStatuses,
    PrescriptionGroupStatuses,
    VoucherStatuses,
    RefundMethods,
    DocumentRequirements,
    PayoutMethods,
    PayoutStatuses,
    CustomerOrderStatuses,
    WeightLossSteps,
    WeightLossConsultSteps,
    LongevitySteps,
    LongevityConsultSteps,
    SiteEventStepNames,
    AffiliateRoles,
    PartnerRoles,
    CheckInTypes,
    CheckInStatuses,
    MealPlanStatuses,
    MealTypes,
    MealDays,
    MealPlanReviewStatuses,
    VendorPaymentMethods,
    TitrationSchedules,
    EventTypes,
    EventStatuses,
    EventPlatforms,
    CommunityTypes,
    CommunityPrivacies,
    TaskCategories,
    TaskTypes,
    TicketChannels,
    EscalationLevels,
    TicketEventTypes,
    SupportReplyTemplateChannels,
    SupportHandoffTypes,
    SupportRoutingStatuses,
    SupportPresenceModes,
    SupportViewScopes,
    NewDashboardTutorialStatuses,
    TaskStatuses,
    TaskPriorities,
    WalletTransactionType,
    CurrencyType,
    HabitCategories,
    Frequency,
    CancellationReasons,
    PauseReasons,
    SatisfactionRatings,
    RecommendationOptions,
    CancellationRequestStatuses,
    Priorities,
    CancellationRequestResolutionTypes,
    CancellationRequestRetentionOfferTypes,
    Carriers,
    CarrierShippingMethods,
    MedicationAdministrationRoutes,
    MedicationInjectionSites,
    HydrationStatuses,
    WellnessResponseScores,
    PaymentGateways,
    MealPlanGoals,
    AddOnQuantityModes,
    AddOnScopes,
    AddOnShipmentQuantityModes,
    AddOnSources,
    EmailIngestionDispositions,
    EmailIngestionReasons,
    EmailSources,
    EmailDeliveryStatuses,
    CommunicationChannels,
    AddressVerificationStatuses,
    CommunicationClassifications,
    CommunicationPreferenceEventActions,
    CommunicationPreferenceSources,
    SmsSenders,
    WeightHistorySources,
    ExperimentAssignmentSources,
    GmailImportLogStatuses,
    GmailImportLogReasons,
    OrderGroupStatuses,
    OrderGroupTypes,
    BiomarkerValueTypes,
    BiomarkerFrequencies,
    SexApplicability,
    PanelTypes,
    TestScheduleTypes,
    CollectionMethods,
    LabInterpretations,
    OptimalInterpretations,
    HealthScoreLabels,
    InsightTypes,
    InsightPriorities,
    InsightActionTypes,
    HealthCategories,
    BiomarkerClassifications,
    UserTestTriggerTypes,
    EmailTemplateTypes,
    FunnelExperimentScopes,
    FunnelExperimentStatuses,
    OtpChannels,
    QueueKeys,
    QueueJobStatuses,
    QueueJobRunStatuses,
    QueueRunTriggers,
    AgreementGenerationOutcomes,
    AgreementIpAddressSources,
    CaptureReviewReasons
};

export default Enums;
